import { Phrase, Conversation } from "./types";

export const phrases: Phrase[] = [
  // --- CHÀO HỎI (GREETINGS) [IDs: 1-23] ---
  {
    id: 1,
    japanese: "おはようございます",
    romaji: "Ohayou gozaimasu",
    vietnamese: "Chào buổi sáng",
    category: "Chào hỏi",
  },
  {
    id: 2,
    japanese: "こんにちは",
    romaji: "Konnichiwa",
    vietnamese: "Xin chào (buổi trưa/chung)",
    category: "Chào hỏi",
  },
  {
    id: 3,
    japanese: "こんばんは",
    romaji: "Konbanwa",
    vietnamese: "Chào buổi tối",
    category: "Chào hỏi",
  },
  {
    id: 4,
    japanese: "おやすみなさい",
    romaji: "Oyasuminasai",
    vietnamese: "Chúc ngủ ngon",
    category: "Chào hỏi",
  },
  {
    id: 5,
    japanese: "さようなら",
    romaji: "Sayounara",
    vietnamese: "Tạm biệt",
    category: "Chào hỏi",
  },
  {
    id: 6,
    japanese: "ありがとうございます",
    romaji: "Arigatou gozaimasu",
    vietnamese: "Cảm ơn rất nhiều",
    category: "Chào hỏi",
  },
  {
    id: 7,
    japanese: "すみません",
    romaji: "Sumimasen",
    vietnamese: "Xin lỗi / Cho tôi hỏi (Excuse me)",
    category: "Chào hỏi",
  },
  {
    id: 8,
    japanese: "ごめんなさい",
    romaji: "Gomennasai",
    vietnamese: "Xin lỗi (khi làm sai)",
    category: "Chào hỏi",
  },
  {
    id: 9,
    japanese: "お元気ですか？",
    romaji: "Ogenki desu ka?",
    vietnamese: "Bạn có khỏe không?",
    category: "Chào hỏi",
  },
  {
    id: 10,
    japanese: "元気です",
    romaji: "Genki desu",
    vietnamese: "Tôi khỏe",
    category: "Chào hỏi",
  },
  {
    id: 11,
    japanese: "またね",
    romaji: "Mata ne",
    vietnamese: "Hẹn gặp lại nhé (thân mật)",
    category: "Chào hỏi",
  },
  {
    id: 12,
    japanese: "いってきます",
    romaji: "Ittekimasu",
    vietnamese: "Tôi đi đây (người đi nói)",
    category: "Chào hỏi",
  },
  {
    id: 13,
    japanese: "いってらっしゃい",
    romaji: "Itterasshai",
    vietnamese: "Bạn đi nhé (người ở nhà nói)",
    category: "Chào hỏi",
  },
  {
    id: 14,
    japanese: "明けましておめでとうございます",
    romaji: "Akemashite omedetou gozaimasu",
    vietnamese: "Chúc mừng năm mới",
    category: "Chào hỏi",
  },
  {
    id: 15,
    japanese: "良いお年を",
    romaji: "Yoi otoshi wo",
    vietnamese: "Chúc một năm mới tốt lành (trước giao thừa)",
    category: "Chào hỏi",
  },
  {
    id: 16,
    japanese: "お先に失礼します",
    romaji: "Osaki ni shitsurei shimasu",
    vietnamese: "Tôi xin phép về trước",
    category: "Chào hỏi",
  },
  {
    id: 17,
    japanese: "ただいま",
    romaji: "Tadaima",
    vietnamese: "Tôi đã về rồi đây",
    category: "Chào hỏi",
  },
  {
    id: 18,
    japanese: "おかえりなさい",
    romaji: "Okaerinasai",
    vietnamese: "Mừng bạn đã về",
    category: "Chào hỏi",
  },
  {
    id: 19,
    japanese: "もしもし",
    romaji: "Moshi moshi",
    vietnamese: "A lô (nghe điện thoại)",
    category: "Chào hỏi",
  },
  {
    id: 20,
    japanese: "どういたしまして",
    romaji: "Douitashimashite",
    vietnamese: "Không có chi",
    category: "Chào hỏi",
  },
  {
    id: 21,
    japanese: "お大事に",
    romaji: "Odaiji ni",
    vietnamese: "Mau khỏe nhé (nói với người ốm)",
    category: "Chào hỏi",
  },
  {
    id: 22,
    japanese: "ご無沙汰しております",
    romaji: "Gobusata shite orimasu",
    vietnamese: "Đã lâu không gặp (kính ngữ)",
    category: "Chào hỏi",
  },
  {
    id: 23,
    japanese: "ようこそ",
    romaji: "Youkoso",
    vietnamese: "Chào mừng",
    category: "Chào hỏi",
  },

  // --- GIỚI THIỆU (SELF INTRODUCTION) [IDs: 24-44] ---
  {
    id: 24,
    japanese: "はじめまして",
    romaji: "Hajimemashite",
    vietnamese: "Rất vui được gặp bạn (lần đầu)",
    category: "Giới thiệu",
  },
  {
    id: 25,
    japanese: "私はベトナム人です",
    romaji: "Watashi wa Betonamu-jin desu",
    vietnamese: "Tôi là người Việt Nam",
    category: "Giới thiệu",
  },
  {
    id: 26,
    japanese: "ベトナムから来ました",
    romaji: "Betonamu kara kimashita",
    vietnamese: "Tôi đến từ Việt Nam",
    category: "Giới thiệu",
  },
  {
    id: 27,
    japanese: "名前は何ですか？",
    romaji: "Namae wa nan desu ka?",
    vietnamese: "Tên bạn là gì?",
    category: "Giới thiệu",
  },
  {
    id: 28,
    japanese: "私の名前はAです",
    romaji: "Watashi no namae wa A desu",
    vietnamese: "Tên tôi là A",
    category: "Giới thiệu",
  },
  {
    id: 29,
    japanese: "よろしくお願いします",
    romaji: "Yoroshiku onegaishimasu",
    vietnamese: "Mong được giúp đỡ",
    category: "Giới thiệu",
  },
  {
    id: 30,
    japanese: "英語が話せますか？",
    romaji: "Eigo ga hanasemasu ka?",
    vietnamese: "Bạn có nói được tiếng Anh không?",
    category: "Giới thiệu",
  },
  {
    id: 31,
    japanese: "日本語が少ししか話せません",
    romaji: "Nihongo ga sukoshi shika hanasemasen",
    vietnamese: "Tôi chỉ nói được một chút tiếng Nhật",
    category: "Giới thiệu",
  },
  {
    id: 32,
    japanese: "わかりません",
    romaji: "Wakarimasen",
    vietnamese: "Tôi không hiểu",
    category: "Giới thiệu",
  },
  {
    id: 33,
    japanese: "もう一度お願いします",
    romaji: "Mou ichido onegaishimasu",
    vietnamese: "Làm ơn nhắc lại lần nữa",
    category: "Giới thiệu",
  },
  {
    id: 34,
    japanese: "趣味",
    romaji: "Shumi",
    vietnamese: "Sở thích",
    category: "Giới thiệu",
  },
  {
    id: 35,
    japanese: "特技",
    romaji: "Tokugi",
    vietnamese: "Sở trường/Kỹ năng đặc biệt",
    category: "Giới thiệu",
  },
  {
    id: 36,
    japanese: "出身",
    romaji: "Shusshin",
    vietnamese: "Xuất thân/Quê quán",
    category: "Giới thiệu",
  },
  {
    id: 37,
    japanese: "専攻",
    romaji: "Senkou",
    vietnamese: "Chuyên ngành",
    category: "Giới thiệu",
  },
  {
    id: 38,
    japanese: "大学生",
    romaji: "Daigakusei",
    vietnamese: "Sinh viên đại học",
    category: "Giới thiệu",
  },
  {
    id: 39,
    japanese: "留学生",
    romaji: "Ryuugakusei",
    vietnamese: "Du học sinh",
    category: "Giới thiệu",
  },
  {
    id: 40,
    japanese: "〜と呼んでください",
    romaji: "~to yonde kudasai",
    vietnamese: "Hãy gọi tôi là ~",
    category: "Giới thiệu",
  },
  {
    id: 41,
    japanese: "今年〜歳になります",
    romaji: "Kotoshi ~sai ni narimasu",
    vietnamese: "Năm nay tôi sẽ sang tuổi ~",
    category: "Giới thiệu",
  },
  {
    id: 42,
    japanese: "住所",
    romaji: "Juusho",
    vietnamese: "Địa chỉ",
    category: "Giới thiệu",
  },
  {
    id: 43,
    japanese: "電話番号",
    romaji: "Denwa bangou",
    vietnamese: "Số điện thoại",
    category: "Giới thiệu",
  },
  {
    id: 44,
    japanese: "独身です",
    romaji: "Dokushin desu",
    vietnamese: "Độc thân",
    category: "Giới thiệu",
  },

  // --- GIAO TIẾP (GENERAL COMMUNICATION) [IDs: 45-65] ---
  {
    id: 45,
    japanese: "はい",
    romaji: "Hai",
    vietnamese: "Vâng / Có",
    category: "Giao tiếp",
  },
  {
    id: 46,
    japanese: "いいえ",
    romaji: "Iie",
    vietnamese: "Không",
    category: "Giao tiếp",
  },
  {
    id: 47,
    japanese: "そうです",
    romaji: "Sou desu",
    vietnamese: "Đúng vậy",
    category: "Giao tiếp",
  },
  {
    id: 48,
    japanese: "違います",
    romaji: "Chigaimasu",
    vietnamese: "Sai rồi / Không phải",
    category: "Giao tiếp",
  },
  {
    id: 49,
    japanese: "もっとゆっくり話してください",
    romaji: "Motto yukkuri hanashite kudasai",
    vietnamese: "Làm ơn nói chậm hơn một chút",
    category: "Giao tiếp",
  },
  {
    id: 50,
    japanese: "書いてください",
    romaji: "Kaite kudasai",
    vietnamese: "Làm ơn viết ra giúp tôi",
    category: "Giao tiếp",
  },
  {
    id: 51,
    japanese: "大丈夫です",
    romaji: "Daijoubu desu",
    vietnamese: "Không sao đâu / Tôi ổn",
    category: "Giao tiếp",
  },
  {
    id: 52,
    japanese: "賛成です",
    romaji: "Sansei desu",
    vietnamese: "Tôi tán thành",
    category: "Giao tiếp",
  },
  {
    id: 53,
    japanese: "反対です",
    romaji: "Hantai desu",
    vietnamese: "Tôi phản đối",
    category: "Giao tiếp",
  },
  {
    id: 54,
    japanese: "なるほど",
    romaji: "Naruhodo",
    vietnamese: "Ra là vậy / Hiểu rồi",
    category: "Giao tiếp",
  },
  {
    id: 55,
    japanese: "もちろん",
    romaji: "Mochiron",
    vietnamese: "Tất nhiên rồi",
    category: "Giao tiếp",
  },
  {
    id: 56,
    japanese: "本当ですか？",
    romaji: "Hontou desu ka?",
    vietnamese: "Thật không?",
    category: "Giao tiếp",
  },
  {
    id: 57,
    japanese: "冗談です",
    romaji: "Joudan desu",
    vietnamese: "Đùa thôi",
    category: "Giao tiếp",
  },
  {
    id: 58,
    japanese: "知りません",
    romaji: "Shirimasen",
    vietnamese: "Tôi không biết",
    category: "Giao tiếp",
  },
  {
    id: 59,
    japanese: "教えてください",
    romaji: "Oshiete kudasai",
    vietnamese: "Hãy chỉ cho tôi",
    category: "Giao tiếp",
  },
  {
    id: 60,
    japanese: "手伝ってください",
    romaji: "Tetsudatte kudasai",
    vietnamese: "Hãy giúp tôi",
    category: "Giao tiếp",
  },
  {
    id: 61,
    japanese: "どう思いますか？",
    romaji: "Dou omoimasu ka?",
    vietnamese: "Bạn nghĩ sao?",
    category: "Giao tiếp",
  },
  {
    id: 62,
    japanese: "頑張ってください",
    romaji: "Ganbatte kudasai",
    vietnamese: "Hãy cố gắng lên",
    category: "Giao tiếp",
  },
  {
    id: 63,
    japanese: "気にしないで",
    romaji: "Ki ni shinaide",
    vietnamese: "Đừng bận tâm",
    category: "Giao tiếp",
  },
  {
    id: 64,
    japanese: "残念です",
    romaji: "Zannen desu",
    vietnamese: "Đáng tiếc thật",
    category: "Giao tiếp",
  },
  {
    id: 65,
    japanese: "助けて！",
    romaji: "Tasukete!",
    vietnamese: "Cứu tôi với! (dùng chung)",
    category: "Giao tiếp",
  },

  // --- MUA SẮM (SHOPPING) [IDs: 66-87] ---
  {
    id: 66,
    japanese: "これはいくらですか？",
    romaji: "Kore wa ikura desu ka?",
    vietnamese: "Cái này bao nhiêu tiền?",
    category: "Mua sắm",
  },
  {
    id: 67,
    japanese: "これをください",
    romaji: "Kore wo kudasai",
    vietnamese: "Cho tôi lấy cái này",
    category: "Mua sắm",
  },
  {
    id: 68,
    japanese: "クレジットカードは使えますか？",
    romaji: "Kurejitto kaado wa tsukaemasu ka?",
    vietnamese: "Có dùng thẻ tín dụng được không?",
    category: "Mua sắm",
  },
  {
    id: 69,
    japanese: "試着してもいいですか？",
    romaji: "Shichaku shitemo ii desu ka?",
    vietnamese: "Tôi thử đồ được không?",
    category: "Mua sắm",
  },
  {
    id: 70,
    japanese: "ちょっと高いです",
    romaji: "Chotto takai desu",
    vietnamese: "Hơi đắt một chút",
    category: "Mua sắm",
  },
  {
    id: 71,
    japanese: "安くしてもらえませんか？",
    romaji: "Yasuku shite moraemasen ka?",
    vietnamese: "Có thể giảm giá không?",
    category: "Mua sắm",
  },
  {
    id: 72,
    japanese: "見ているだけです",
    romaji: "Mite iru dake desu",
    vietnamese: "Tôi chỉ xem thôi",
    category: "Mua sắm",
  },
  {
    id: 73,
    japanese: "これの他の色はありますか？",
    romaji: "Kore no hoka no iro wa arimasu ka?",
    vietnamese: "Cái này có màu khác không?",
    category: "Mua sắm",
  },
  {
    id: 74,
    japanese: "袋はいりません",
    romaji: "Fukuro wa irimasen",
    vietnamese: "Tôi không cần túi",
    category: "Mua sắm",
  },
  {
    id: 75,
    japanese: "レシートをください",
    romaji: "Reshiito wo kudasai",
    vietnamese: "Cho tôi xin hóa đơn",
    category: "Mua sắm",
  },
  {
    id: 76,
    japanese: "免税できますか？",
    romaji: "Menzei dekimasu ka?",
    vietnamese: "Có được miễn thuế không?",
    category: "Mua sắm",
  },
  {
    id: 77,
    japanese: "セール",
    romaji: "Seeru",
    vietnamese: "Giảm giá (Sale)",
    category: "Mua sắm",
  },
  {
    id: 78,
    japanese: "売り切れ",
    romaji: "Urikire",
    vietnamese: "Hết hàng",
    category: "Mua sắm",
  },
  {
    id: 79,
    japanese: "現金",
    romaji: "Genkin",
    vietnamese: "Tiền mặt",
    category: "Mua sắm",
  },
  {
    id: 80,
    japanese: "お釣り",
    romaji: "Otsuri",
    vietnamese: "Tiền thừa",
    category: "Mua sắm",
  },
  {
    id: 81,
    japanese: "プレゼント用です",
    romaji: "Purezento you desu",
    vietnamese: "Gói làm quà tặng",
    category: "Mua sắm",
  },
  {
    id: 82,
    japanese: "サイズ",
    romaji: "Saizu",
    vietnamese: "Kích cỡ",
    category: "Mua sắm",
  },
  {
    id: 83,
    japanese: "色",
    romaji: "Iro",
    vietnamese: "Màu sắc",
    category: "Mua sắm",
  },
  {
    id: 84,
    japanese: "新品",
    romaji: "Shinpin",
    vietnamese: "Hàng mới",
    category: "Mua sắm",
  },
  {
    id: 85,
    japanese: "中古",
    romaji: "Chuuko",
    vietnamese: "Hàng cũ (Second hand)",
    category: "Mua sắm",
  },
  {
    id: 86,
    japanese: "返品",
    romaji: "Henpin",
    vietnamese: "Trả hàng",
    category: "Mua sắm",
  },
  {
    id: 87,
    japanese: "領収書",
    romaji: "Ryoushuusho",
    vietnamese: "Biên lai (viết tay/cho cty)",
    category: "Mua sắm",
  },

  // --- ĂN UỐNG (DINING) [IDs: 88-110] ---
  {
    id: 88,
    japanese: "メニューをください",
    romaji: "Menyuu wo kudasai",
    vietnamese: "Cho tôi xem menu",
    category: "Ăn uống",
  },
  {
    id: 89,
    japanese: "注文をお願いします",
    romaji: "Chuumon wo onegaishimasu",
    vietnamese: "Cho tôi gọi món",
    category: "Ăn uống",
  },
  {
    id: 90,
    japanese: "お水をお願いします",
    romaji: "Omizu wo onegaishimasu",
    vietnamese: "Làm ơn cho tôi nước lọc",
    category: "Ăn uống",
  },
  {
    id: 91,
    japanese: "おすすめは何ですか？",
    romaji: "Osusume wa nan desu ka?",
    vietnamese: "Món gợi ý là gì?",
    category: "Ăn uống",
  },
  {
    id: 92,
    japanese: "これは何ですか？",
    romaji: "Kore wa nan desu ka?",
    vietnamese: "Đây là món gì?",
    category: "Ăn uống",
  },
  {
    id: 93,
    japanese: "辛いですか？",
    romaji: "Karai desu ka?",
    vietnamese: "Có cay không?",
    category: "Ăn uống",
  },
  {
    id: 94,
    japanese: "辛くしないでください",
    romaji: "Karaku shinaide kudasai",
    vietnamese: "Đừng làm cay nhé",
    category: "Ăn uống",
  },
  {
    id: 95,
    japanese: "いただきます",
    romaji: "Itadakimasu",
    vietnamese: "Mời mọi người ăn (nói trước khi ăn)",
    category: "Ăn uống",
  },
  {
    id: 96,
    japanese: "ごちそうさまでした",
    romaji: "Gochisousama deshita",
    vietnamese: "Cảm ơn vì bữa ăn (nói sau khi ăn)",
    category: "Ăn uống",
  },
  {
    id: 97,
    japanese: "お会計をお願いします",
    romaji: "Okaikei wo onegaishimasu",
    vietnamese: "Làm ơn tính tiền",
    category: "Ăn uống",
  },
  {
    id: 98,
    japanese: "とても美味しいです",
    romaji: "Totemo oishii desu",
    vietnamese: "Rất ngon",
    category: "Ăn uống",
  },
  {
    id: 99,
    japanese: "乾杯",
    romaji: "Kanpai",
    vietnamese: "Cạn ly / Dô!",
    category: "Ăn uống",
  },
  {
    id: 100,
    japanese: "甘い",
    romaji: "Amai",
    vietnamese: "Ngọt",
    category: "Ăn uống",
  },
  {
    id: 101,
    japanese: "しょっぱい",
    romaji: "Shoppai",
    vietnamese: "Mặn",
    category: "Ăn uống",
  },
  {
    id: 102,
    japanese: "酸っぱい",
    romaji: "Suppai",
    vietnamese: "Chua",
    category: "Ăn uống",
  },
  {
    id: 103,
    japanese: "苦い",
    romaji: "Nigai",
    vietnamese: "Đắng",
    category: "Ăn uống",
  },
  {
    id: 104,
    japanese: "豚肉",
    romaji: "Butaniku",
    vietnamese: "Thịt lợn",
    category: "Ăn uống",
  },
  {
    id: 105,
    japanese: "鶏肉",
    romaji: "Toriniku",
    vietnamese: "Thịt gà",
    category: "Ăn uống",
  },
  {
    id: 106,
    japanese: "牛肉",
    romaji: "Gyuuniku",
    vietnamese: "Thịt bò",
    category: "Ăn uống",
  },
  {
    id: 107,
    japanese: "野菜",
    romaji: "Yasai",
    vietnamese: "Rau",
    category: "Ăn uống",
  },
  {
    id: 108,
    japanese: "箸",
    romaji: "Hashi",
    vietnamese: "Đũa",
    category: "Ăn uống",
  },
  {
    id: 109,
    japanese: "スプーン",
    romaji: "Supuun",
    vietnamese: "Thìa",
    category: "Ăn uống",
  },
  {
    id: 110,
    japanese: "お持ち帰り",
    romaji: "Omochikaeri",
    vietnamese: "Mang về (Take out)",
    category: "Ăn uống",
  },

  // --- DI CHUYỂN & HỎI ĐƯỜNG (TRAVEL & DIRECTIONS) [IDs: 111-134] ---
  {
    id: 111,
    japanese: "トイレはどこですか？",
    romaji: "Toire wa doko desu ka?",
    vietnamese: "Nhà vệ sinh ở đâu vậy?",
    category: "Di chuyển",
  },
  {
    id: 112,
    japanese: "駅はどこですか？",
    romaji: "Eki wa doko desu ka?",
    vietnamese: "Nhà ga ở đâu?",
    category: "Di chuyển",
  },
  {
    id: 113,
    japanese: "ここはどこですか？",
    romaji: "Koko wa doko desu ka?",
    vietnamese: "Đây là đâu?",
    category: "Di chuyển",
  },
  {
    id: 114,
    japanese: "タクシー乗り場はどこですか？",
    romaji: "Takushii noriba wa doko desu ka?",
    vietnamese: "Bến taxi ở đâu?",
    category: "Di chuyển",
  },
  {
    id: 115,
    japanese: "このバスはAに行きますか？",
    romaji: "Kono basu wa A ni ikimasu ka?",
    vietnamese: "Xe bus này có đi đến A không?",
    category: "Di chuyển",
  },
  {
    id: 116,
    japanese: "切符をください",
    romaji: "Kippu wo kudasai",
    vietnamese: "Cho tôi mua vé",
    category: "Di chuyển",
  },
  {
    id: 117,
    japanese: "右",
    romaji: "Migi",
    vietnamese: "Phải",
    category: "Di chuyển",
  },
  {
    id: 118,
    japanese: "左",
    romaji: "Hidari",
    vietnamese: "Trái",
    category: "Di chuyển",
  },
  {
    id: 119,
    japanese: "まっすぐ",
    romaji: "Massugu",
    vietnamese: "Đi thẳng",
    category: "Di chuyển",
  },
  {
    id: 120,
    japanese: "地図を書いてくれませんか？",
    romaji: "Chizu wo kaite kuremasen ka?",
    vietnamese: "Bạn vẽ bản đồ giúp tôi được không?",
    category: "Di chuyển",
  },
  {
    id: 121,
    japanese: "歩いて行けますか？",
    romaji: "Aruite ikemasu ka?",
    vietnamese: "Có đi bộ được không?",
    category: "Di chuyển",
  },
  {
    id: 122,
    japanese: "遠いですか？",
    romaji: "Tooi desu ka?",
    vietnamese: "Có xa không?",
    category: "Di chuyển",
  },
  {
    id: 123,
    japanese: "乗り換え",
    romaji: "Norikae",
    vietnamese: "Đổi tàu/xe",
    category: "Di chuyển",
  },
  {
    id: 124,
    japanese: "地下鉄",
    romaji: "Chikatetsu",
    vietnamese: "Tàu điện ngầm",
    category: "Di chuyển",
  },
  {
    id: 125,
    japanese: "新幹線",
    romaji: "Shinkansen",
    vietnamese: "Tàu siêu tốc",
    category: "Di chuyển",
  },
  {
    id: 126,
    japanese: "ホーム",
    romaji: "Hoomu",
    vietnamese: "Sân ga (Platform)",
    category: "Di chuyển",
  },
  {
    id: 127,
    japanese: "出口",
    romaji: "Deguchi",
    vietnamese: "Cửa ra",
    category: "Di chuyển",
  },
  {
    id: 128,
    japanese: "入口",
    romaji: "Iriguchi",
    vietnamese: "Cửa vào",
    category: "Di chuyển",
  },
  {
    id: 129,
    japanese: "北口",
    romaji: "Kitaguchi",
    vietnamese: "Cửa Bắc",
    category: "Di chuyển",
  },
  {
    id: 130,
    japanese: "南口",
    romaji: "Minamiguchi",
    vietnamese: "Cửa Nam",
    category: "Di chuyển",
  },
  {
    id: 131,
    japanese: "指定席",
    romaji: "Shiteiseki",
    vietnamese: "Ghế chỉ định (đặt trước)",
    category: "Di chuyển",
  },
  {
    id: 132,
    japanese: "自由席",
    romaji: "Jiyuuseki",
    vietnamese: "Ghế tự do",
    category: "Di chuyển",
  },
  {
    id: 133,
    japanese: "満席",
    romaji: "Manseki",
    vietnamese: "Hết chỗ",
    category: "Di chuyển",
  },
  {
    id: 134,
    japanese: "パスポートをなくしました",
    romaji: "Pasupooto wo nakushimashita",
    vietnamese: "Tôi bị mất hộ chiếu",
    category: "Di chuyển",
  },

  // --- KHÁCH SẠN (HOTEL) [IDs: 135-154] ---
  {
    id: 135,
    japanese: "チェックインをお願いします",
    romaji: "Chekku-in wo onegaishimasu",
    vietnamese: "Tôi muốn làm thủ tục nhận phòng",
    category: "Khách sạn",
  },
  {
    id: 136,
    japanese: "予約しています",
    romaji: "Yoyaku shiteimasu",
    vietnamese: "Tôi đã đặt trước rồi",
    category: "Khách sạn",
  },
  {
    id: 137,
    japanese: "Wi-Fiのパスワードは何ですか？",
    romaji: "Wi-Fi no pasuwaado wa nan desu ka?",
    vietnamese: "Mật khẩu Wifi là gì?",
    category: "Khách sạn",
  },
  {
    id: 138,
    japanese: "朝食は何時からですか？",
    romaji: "Choushoku wa nanji kara desu ka?",
    vietnamese: "Bữa sáng bắt đầu từ mấy giờ?",
    category: "Khách sạn",
  },
  {
    id: 139,
    japanese: "荷物を預かってもらえますか？",
    romaji: "Nimotsu wo azukatte moraemasu ka?",
    vietnamese: "Có thể giữ hành lý giúp tôi được không?",
    category: "Khách sạn",
  },
  {
    id: 140,
    japanese: "チェックアウトしたいです",
    romaji: "Chekku-auto shitai desu",
    vietnamese: "Tôi muốn trả phòng",
    category: "Khách sạn",
  },
  {
    id: 141,
    japanese: "鍵",
    romaji: "Kagi",
    vietnamese: "Chìa khóa",
    category: "Khách sạn",
  },
  {
    id: 142,
    japanese: "禁煙ルーム",
    romaji: "Kin'en ruumu",
    vietnamese: "Phòng không hút thuốc",
    category: "Khách sạn",
  },
  {
    id: 143,
    japanese: "喫煙ルーム",
    romaji: "Kitsuen ruumu",
    vietnamese: "Phòng hút thuốc",
    category: "Khách sạn",
  },
  {
    id: 144,
    japanese: "シングル",
    romaji: "Shinguru",
    vietnamese: "Phòng đơn",
    category: "Khách sạn",
  },
  {
    id: 145,
    japanese: "ダブル",
    romaji: "Daburu",
    vietnamese: "Phòng đôi (1 giường lớn)",
    category: "Khách sạn",
  },
  {
    id: 146,
    japanese: "ツイン",
    romaji: "Tsuin",
    vietnamese: "Phòng đôi (2 giường đơn)",
    category: "Khách sạn",
  },
  {
    id: 147,
    japanese: "空室",
    romaji: "Kuushitsu",
    vietnamese: "Phòng trống",
    category: "Khách sạn",
  },
  {
    id: 148,
    japanese: "満室",
    romaji: "Manshitsu",
    vietnamese: "Hết phòng",
    category: "Khách sạn",
  },
  {
    id: 149,
    japanese: "タオル",
    romaji: "Taoru",
    vietnamese: "Khăn tắm",
    category: "Khách sạn",
  },
  {
    id: 150,
    japanese: "石鹸",
    romaji: "Sekken",
    vietnamese: "Xà phòng",
    category: "Khách sạn",
  },
  {
    id: 151,
    japanese: "シャンプー",
    romaji: "Shanpuu",
    vietnamese: "Dầu gội",
    category: "Khách sạn",
  },
  {
    id: 152,
    japanese: "ドライヤー",
    romaji: "Doraiyaa",
    vietnamese: "Máy sấy tóc",
    category: "Khách sạn",
  },
  {
    id: 153,
    japanese: "金庫",
    romaji: "Kinko",
    vietnamese: "Két sắt",
    category: "Khách sạn",
  },
  {
    id: 154,
    japanese: "ルームサービス",
    romaji: "Ruumu saabisu",
    vietnamese: "Dịch vụ phòng",
    category: "Khách sạn",
  },

  // --- KHẨN CẤP (EMERGENCY) [IDs: 155-174] ---
  {
    id: 155,
    japanese: "警察を呼んでください",
    romaji: "Keisatsu wo yonde kudasai",
    vietnamese: "Hãy gọi cảnh sát giúp tôi",
    category: "Khẩn cấp",
  },
  {
    id: 156,
    japanese: "救急車を呼んでください",
    romaji: "Kyuukyuusha wo yonde kudasai",
    vietnamese: "Hãy gọi xe cấp cứu",
    category: "Khẩn cấp",
  },
  {
    id: 157,
    japanese: "病院はどこですか？",
    romaji: "Byouin wa doko desu ka?",
    vietnamese: "Bệnh viện ở đâu?",
    category: "Khẩn cấp",
  },
  {
    id: 158,
    japanese: "気分が悪いです",
    romaji: "Kibun ga warui desu",
    vietnamese: "Tôi cảm thấy không khỏe/khó chịu",
    category: "Khẩn cấp",
  },
  {
    id: 159,
    japanese: "財布を盗まれました",
    romaji: "Saifu wo nusumaremashita",
    vietnamese: "Tôi bị trộm mất ví",
    category: "Khẩn cấp",
  },
  {
    id: 160,
    japanese: "痛い",
    romaji: "Itai",
    vietnamese: "Đau",
    category: "Khẩn cấp",
  },
  {
    id: 161,
    japanese: "熱",
    romaji: "Netsu",
    vietnamese: "Sốt",
    category: "Khẩn cấp",
  },
  {
    id: 162,
    japanese: "風邪",
    romaji: "Kaze",
    vietnamese: "Cảm cúm",
    category: "Khẩn cấp",
  },
  {
    id: 163,
    japanese: "腹痛",
    romaji: "Fukutsuu",
    vietnamese: "Đau bụng",
    category: "Khẩn cấp",
  },
  {
    id: 164,
    japanese: "事故",
    romaji: "Jiko",
    vietnamese: "Tai nạn",
    category: "Khẩn cấp",
  },
  {
    id: 165,
    japanese: "泥棒",
    romaji: "Dorobou",
    vietnamese: "Kẻ trộm",
    category: "Khẩn cấp",
  },
  {
    id: 166,
    japanese: "交番",
    romaji: "Kouban",
    vietnamese: "Đồn cảnh sát",
    category: "Khẩn cấp",
  },
  {
    id: 167,
    japanese: "大使館",
    romaji: "Taishikan",
    vietnamese: "Đại sứ quán",
    category: "Khẩn cấp",
  },
  {
    id: 168,
    japanese: "地震",
    romaji: "Jishin",
    vietnamese: "Động đất",
    category: "Khẩn cấp",
  },
  {
    id: 169,
    japanese: "火事",
    romaji: "Kaji",
    vietnamese: "Hỏa hoạn",
    category: "Khẩn cấp",
  },
  {
    id: 170,
    japanese: "逃げて",
    romaji: "Nigete",
    vietnamese: "Chạy đi",
    category: "Khẩn cấp",
  },
  {
    id: 171,
    japanese: "止まれ",
    romaji: "Tomare",
    vietnamese: "Dừng lại",
    category: "Khẩn cấp",
  },
  {
    id: 172,
    japanese: "危ない",
    romaji: "Abunai",
    vietnamese: "Nguy hiểm",
    category: "Khẩn cấp",
  },
  {
    id: 173,
    japanese: "薬",
    romaji: "Kusuri",
    vietnamese: "Thuốc",
    category: "Khẩn cấp",
  },
  {
    id: 174,
    japanese: "アレルギー",
    romaji: "Arerugii",
    vietnamese: "Dị ứng",
    category: "Khẩn cấp",
  },

  // --- GIA ĐÌNH (FAMILY) [IDs: 175-194] ---
  {
    id: 175,
    japanese: "家族",
    romaji: "Kazoku",
    vietnamese: "Gia đình",
    category: "Gia đình",
  },
  {
    id: 176,
    japanese: "父",
    romaji: "Chichi",
    vietnamese: "Bố (của tôi)",
    category: "Gia đình",
  },
  {
    id: 177,
    japanese: "母",
    romaji: "Haha",
    vietnamese: "Mẹ (của tôi)",
    category: "Gia đình",
  },
  {
    id: 178,
    japanese: "お父さん",
    romaji: "Otousan",
    vietnamese: "Bố (của người khác)",
    category: "Gia đình",
  },
  {
    id: 179,
    japanese: "お母さん",
    romaji: "Okaasan",
    vietnamese: "Mẹ (của người khác)",
    category: "Gia đình",
  },
  {
    id: 180,
    japanese: "兄弟",
    romaji: "Kyoudai",
    vietnamese: "Anh chị em",
    category: "Gia đình",
  },
  {
    id: 181,
    japanese: "兄",
    romaji: "Ani",
    vietnamese: "Anh trai (của tôi)",
    category: "Gia đình",
  },
  {
    id: 182,
    japanese: "姉",
    romaji: "Ane",
    vietnamese: "Chị gái (của tôi)",
    category: "Gia đình",
  },
  {
    id: 183,
    japanese: "弟",
    romaji: "Otouto",
    vietnamese: "Em trai (của tôi)",
    category: "Gia đình",
  },
  {
    id: 184,
    japanese: "妹",
    romaji: "Imouto",
    vietnamese: "Em gái (của tôi)",
    category: "Gia đình",
  },
  {
    id: 185,
    japanese: "結婚しています",
    romaji: "Kekkon shiteimasu",
    vietnamese: "Đã kết hôn",
    category: "Gia đình",
  },
  {
    id: 186,
    japanese: "祖父",
    romaji: "Sofu",
    vietnamese: "Ông (của tôi)",
    category: "Gia đình",
  },
  {
    id: 187,
    japanese: "祖母",
    romaji: "Sobo",
    vietnamese: "Bà (của tôi)",
    category: "Gia đình",
  },
  {
    id: 188,
    japanese: "夫",
    romaji: "Otto",
    vietnamese: "Chồng (của tôi)",
    category: "Gia đình",
  },
  {
    id: 189,
    japanese: "妻",
    romaji: "Tsuma",
    vietnamese: "Vợ (của tôi)",
    category: "Gia đình",
  },
  {
    id: 190,
    japanese: "息子",
    romaji: "Musuko",
    vietnamese: "Con trai (của tôi)",
    category: "Gia đình",
  },
  {
    id: 191,
    japanese: "娘",
    romaji: "Musume",
    vietnamese: "Con gái (của tôi)",
    category: "Gia đình",
  },
  {
    id: 192,
    japanese: "ペット",
    romaji: "Petto",
    vietnamese: "Thú cưng",
    category: "Gia đình",
  },
  {
    id: 193,
    japanese: "親戚",
    romaji: "Shinseki",
    vietnamese: "Họ hàng",
    category: "Gia đình",
  },
  {
    id: 194,
    japanese: "孫",
    romaji: "Mago",
    vietnamese: "Cháu",
    category: "Gia đình",
  },

  // --- THỜI TIẾT (WEATHER) [IDs: 195-214] ---
  {
    id: 195,
    japanese: "天気",
    romaji: "Tenki",
    vietnamese: "Thời tiết",
    category: "Thời tiết",
  },
  {
    id: 196,
    japanese: "春",
    romaji: "Haru",
    vietnamese: "Mùa xuân",
    category: "Thời tiết",
  },
  {
    id: 197,
    japanese: "夏",
    romaji: "Natsu",
    vietnamese: "Mùa hè",
    category: "Thời tiết",
  },
  {
    id: 198,
    japanese: "秋",
    romaji: "Aki",
    vietnamese: "Mùa thu",
    category: "Thời tiết",
  },
  {
    id: 199,
    japanese: "冬",
    romaji: "Fuyu",
    vietnamese: "Mùa đông",
    category: "Thời tiết",
  },
  {
    id: 200,
    japanese: "暑い",
    romaji: "Atsui",
    vietnamese: "Nóng",
    category: "Thời tiết",
  },
  {
    id: 201,
    japanese: "寒い",
    romaji: "Samui",
    vietnamese: "Lạnh",
    category: "Thời tiết",
  },
  {
    id: 202,
    japanese: "雨",
    romaji: "Ame",
    vietnamese: "Mưa",
    category: "Thời tiết",
  },
  {
    id: 203,
    japanese: "雪",
    romaji: "Yuki",
    vietnamese: "Tuyết",
    category: "Thời tiết",
  },
  {
    id: 204,
    japanese: "晴れ",
    romaji: "Hare",
    vietnamese: "Nắng / Quang đãng",
    category: "Thời tiết",
  },
  {
    id: 205,
    japanese: "曇り",
    romaji: "Kumori",
    vietnamese: "Nhiều mây / Âm u",
    category: "Thời tiết",
  },
  {
    id: 206,
    japanese: "風",
    romaji: "Kaze",
    vietnamese: "Gió",
    category: "Thời tiết",
  },
  {
    id: 207,
    japanese: "台風",
    romaji: "Taifuu",
    vietnamese: "Bão",
    category: "Thời tiết",
  },
  {
    id: 208,
    japanese: "湿度",
    romaji: "Shitsudo",
    vietnamese: "Độ ẩm",
    category: "Thời tiết",
  },
  {
    id: 209,
    japanese: "蒸し暑い",
    romaji: "Mushiatsui",
    vietnamese: "Oi bức",
    category: "Thời tiết",
  },
  {
    id: 210,
    japanese: "天気予報",
    romaji: "Tenki yohou",
    vietnamese: "Dự báo thời tiết",
    category: "Thời tiết",
  },
  {
    id: 211,
    japanese: "傘",
    romaji: "Kasa",
    vietnamese: "Cái ô",
    category: "Thời tiết",
  },
  {
    id: 212,
    japanese: "気温",
    romaji: "Kion",
    vietnamese: "Nhiệt độ",
    category: "Thời tiết",
  },
  {
    id: 213,
    japanese: "何度",
    romaji: "Nando",
    vietnamese: "Bao nhiêu độ",
    category: "Thời tiết",
  },
  {
    id: 214,
    japanese: "雷",
    romaji: "Kaminari",
    vietnamese: "Sấm sét",
    category: "Thời tiết",
  },

  // --- CÔNG VIỆC (WORK) [IDs: 215-234] ---
  {
    id: 215,
    japanese: "会社",
    romaji: "Kaisha",
    vietnamese: "Công ty",
    category: "Công việc",
  },
  {
    id: 216,
    japanese: "仕事",
    romaji: "Shigoto",
    vietnamese: "Công việc",
    category: "Công việc",
  },
  {
    id: 217,
    japanese: "会社員",
    romaji: "Kaishain",
    vietnamese: "Nhân viên công ty",
    category: "Công việc",
  },
  {
    id: 218,
    japanese: "会議",
    romaji: "Kaigi",
    vietnamese: "Cuộc họp",
    category: "Công việc",
  },
  {
    id: 219,
    japanese: "残業",
    romaji: "Zangyou",
    vietnamese: "Làm thêm giờ",
    category: "Công việc",
  },
  {
    id: 220,
    japanese: "電話",
    romaji: "Denwa",
    vietnamese: "Điện thoại",
    category: "Công việc",
  },
  {
    id: 221,
    japanese: "名刺",
    romaji: "Meishi",
    vietnamese: "Danh thiếp",
    category: "Công việc",
  },
  {
    id: 222,
    japanese: "パソコン",
    romaji: "Pasokon",
    vietnamese: "Máy tính cá nhân",
    category: "Công việc",
  },
  {
    id: 223,
    japanese: "休憩",
    romaji: "Kyuukei",
    vietnamese: "Nghỉ giải lao",
    category: "Công việc",
  },
  {
    id: 224,
    japanese: "お疲れ様です",
    romaji: "Otsukaresama desu",
    vietnamese: "Chào hỏi khi làm việc (Cảm ơn vì đã vất vả)",
    category: "Công việc",
  },
  {
    id: 225,
    japanese: "社長",
    romaji: "Shachou",
    vietnamese: "Giám đốc",
    category: "Công việc",
  },
  {
    id: 226,
    japanese: "部長",
    romaji: "Buchou",
    vietnamese: "Trưởng phòng",
    category: "Công việc",
  },
  {
    id: 227,
    japanese: "同僚",
    romaji: "Douryou",
    vietnamese: "Đồng nghiệp",
    category: "Công việc",
  },
  {
    id: 228,
    japanese: "締め切り",
    romaji: "Shimekiri",
    vietnamese: "Hạn chót (Deadline)",
    category: "Công việc",
  },
  {
    id: 229,
    japanese: "報告",
    romaji: "Houkoku",
    vietnamese: "Báo cáo",
    category: "Công việc",
  },
  {
    id: 230,
    japanese: "連絡",
    romaji: "Renraku",
    vietnamese: "Liên lạc",
    category: "Công việc",
  },
  {
    id: 231,
    japanese: "相談",
    romaji: "Soudan",
    vietnamese: "Thảo luận / Xin lời khuyên",
    category: "Công việc",
  },
  {
    id: 232,
    japanese: "給料",
    romaji: "Kyuuryou",
    vietnamese: "Lương",
    category: "Công việc",
  },
  {
    id: 233,
    japanese: "ボーナス",
    romaji: "Boonasu",
    vietnamese: "Tiền thưởng",
    category: "Công việc",
  },
  {
    id: 234,
    japanese: "退職",
    romaji: "Taishoku",
    vietnamese: "Nghỉ việc",
    category: "Công việc",
  },

  // --- THỜI GIAN & KHÁC (TIME & OTHERS) [IDs: 235-254] ---
  {
    id: 235,
    japanese: "今何時ですか？",
    romaji: "Ima nanji desu ka?",
    vietnamese: "Bây giờ là mấy giờ?",
    category: "Khác",
  },
  {
    id: 236,
    japanese: "今日",
    romaji: "Kyou",
    vietnamese: "Hôm nay",
    category: "Khác",
  },
  {
    id: 237,
    japanese: "明日",
    romaji: "Ashita",
    vietnamese: "Ngày mai",
    category: "Khác",
  },
  {
    id: 238,
    japanese: "昨日",
    romaji: "Kinou",
    vietnamese: "Hôm qua",
    category: "Khác",
  },
  {
    id: 239,
    japanese: "毎日",
    romaji: "Mainichi",
    vietnamese: "Mỗi ngày",
    category: "Khác",
  },
  {
    id: 240,
    japanese: "一",
    romaji: "Ichi",
    vietnamese: "Số 1",
    category: "Khác",
  },
  {
    id: 241,
    japanese: "二",
    romaji: "Ni",
    vietnamese: "Số 2",
    category: "Khác",
  },
  {
    id: 242,
    japanese: "三",
    romaji: "San",
    vietnamese: "Số 3",
    category: "Khác",
  },
  {
    id: 243,
    japanese: "十",
    romaji: "Juu",
    vietnamese: "Số 10",
    category: "Khác",
  },
  {
    id: 244,
    japanese: "百",
    romaji: "Hyaku",
    vietnamese: "100",
    category: "Khác",
  },
  {
    id: 245,
    japanese: "千",
    romaji: "Sen",
    vietnamese: "1000",
    category: "Khác",
  },
  {
    id: 246,
    japanese: "万",
    romaji: "Man",
    vietnamese: "10,000 (1 vạn)",
    category: "Khác",
  },
  {
    id: 247,
    japanese: "先週",
    romaji: "Senshuu",
    vietnamese: "Tuần trước",
    category: "Khác",
  },
  {
    id: 248,
    japanese: "来週",
    romaji: "Raishuu",
    vietnamese: "Tuần sau",
    category: "Khác",
  },
  {
    id: 249,
    japanese: "先月",
    romaji: "Sengetsu",
    vietnamese: "Tháng trước",
    category: "Khác",
  },
  {
    id: 250,
    japanese: "来月",
    romaji: "Raigetsu",
    vietnamese: "Tháng sau",
    category: "Khác",
  },
  {
    id: 251,
    japanese: "去年",
    romaji: "Kyonen",
    vietnamese: "Năm ngoái",
    category: "Khác",
  },
  {
    id: 252,
    japanese: "来年",
    romaji: "Rainen",
    vietnamese: "Năm sau",
    category: "Khác",
  },
  {
    id: 253,
    japanese: "午前",
    romaji: "Gozen",
    vietnamese: "Buổi sáng (AM)",
    category: "Khác",
  },
  {
    id: 254,
    japanese: "午後",
    romaji: "Gogo",
    vietnamese: "Buổi chiều (PM)",
    category: "Khác",
  },
];

export const conversations: Conversation[] = [
  // --- 1. CHÀO HỎI (GREETINGS) [IDs: 1-10] ---
  {
    id: 1,
    title: "Chào hỏi giáo viên",
    category: "Chào hỏi",
    lines: [
      {
        role: "A",
        japanese: "先生、おはようございます。",
        romaji: "Sensei, ohayou gozaimasu.",
        vietnamese: "Chào buổi sáng cô giáo.",
      },
      {
        role: "B",
        japanese: "おはよう、アンさん。元気ですか？",
        romaji: "Ohayou, An-san. Genki desu ka?",
        vietnamese: "Chào buổi sáng, An. Em có khỏe không?",
      },
      {
        role: "A",
        japanese: "はい、元気です。",
        romaji: "Hai, genki desu.",
        vietnamese: "Vâng, em khỏe ạ.",
      },
    ],
  },
  {
    id: 2,
    title: "Chào tạm biệt bạn bè",
    category: "Chào hỏi",
    lines: [
      {
        role: "A",
        japanese: "じゃあ、また明日。",
        romaji: "Jaa, mata ashita.",
        vietnamese: "Vậy, mai gặp nhé.",
      },
      {
        role: "B",
        japanese: "うん、またね。",
        romaji: "Un, mata ne.",
        vietnamese: "Ừ, hẹn gặp lại.",
      },
    ],
  },
  {
    id: 3,
    title: "Gặp hàng xóm",
    category: "Chào hỏi",
    lines: [
      {
        role: "A",
        japanese: "こんにちは、いい天気ですね。",
        romaji: "Konnichiwa, ii tenki desu ne.",
        vietnamese: "Xin chào, thời tiết đẹp nhỉ.",
      },
      {
        role: "B",
        japanese: "そうですね。お出かけですか？",
        romaji: "Sou desu ne. Odekake desu ka?",
        vietnamese: "Đúng vậy. Bạn đi ra ngoài à?",
      },
      {
        role: "A",
        japanese: "ええ、ちょっとスーパーまで。",
        romaji: "Ee, chotto suupaa made.",
        vietnamese: "Vâng, tôi ra siêu thị một chút.",
      },
    ],
  },
  {
    id: 4,
    title: "Lâu ngày không gặp",
    category: "Chào hỏi",
    lines: [
      {
        role: "A",
        japanese: "お久しぶりです。",
        romaji: "Ohisashiburi desu.",
        vietnamese: "Lâu rồi không gặp.",
      },
      {
        role: "B",
        japanese: "あ、田中さん！お元気でしたか？",
        romaji: "A, Tanaka-san! Ogenki deshita ka?",
        vietnamese: "A, Tanaka! Bạn vẫn khỏe chứ?",
      },
      {
        role: "A",
        japanese: "はい、おかげさまで。",
        romaji: "Hai, okagesama de.",
        vietnamese: "Vâng, trộm vía tôi vẫn khỏe.",
      },
    ],
  },
  {
    id: 5,
    title: "Chào khách đến nhà",
    category: "Chào hỏi",
    lines: [
      {
        role: "A",
        japanese: "いらっしゃい。どうぞ上がってください。",
        romaji: "Irasshai. Douzo agatte kudasai.",
        vietnamese: "Chào mừng. Mời vào nhà.",
      },
      {
        role: "B",
        japanese: "お邪魔します。",
        romaji: "Ojama shimasu.",
        vietnamese: "Xin phép làm phiền ạ.",
      },
    ],
  },
  {
    id: 6,
    title: "Cảm ơn vì món quà",
    category: "Chào hỏi",
    lines: [
      {
        role: "A",
        japanese: "これ、お土産です。",
        romaji: "Kore, omiyage desu.",
        vietnamese: "Đây là quà lưu niệm.",
      },
      {
        role: "B",
        japanese: "わあ、ありがとうございます。",
        romaji: "Waa, arigatou gozaimasu.",
        vietnamese: "Oa, cảm ơn bạn rất nhiều.",
      },
    ],
  },
  {
    id: 7,
    title: "Xin lỗi khi đến muộn",
    category: "Chào hỏi",
    lines: [
      {
        role: "A",
        japanese: "遅れてすみません。",
        romaji: "Okurete sumimasen.",
        vietnamese: "Xin lỗi vì tôi đến muộn.",
      },
      {
        role: "B",
        japanese: "大丈夫ですよ。",
        romaji: "Daijoubu desu yo.",
        vietnamese: "Không sao đâu.",
      },
    ],
  },
  {
    id: 8,
    title: "Chúc mừng năm mới",
    category: "Chào hỏi",
    lines: [
      {
        role: "A",
        japanese: "明けましておめでとうございます。",
        romaji: "Akemashite omedetou gozaimasu.",
        vietnamese: "Chúc mừng năm mới.",
      },
      {
        role: "B",
        japanese: "今年もよろしくお願いします。",
        romaji: "Kotoshi mo yoroshiku onegaishimasu.",
        vietnamese: "Năm nay cũng mong được giúp đỡ nhé.",
      },
    ],
  },
  {
    id: 9,
    title: "Chào khi ra khỏi nhà",
    category: "Chào hỏi",
    lines: [
      {
        role: "A",
        japanese: "いってきます。",
        romaji: "Ittekimasu.",
        vietnamese: "Tôi đi đây.",
      },
      {
        role: "B",
        japanese: "いってらっしゃい。気をつけて。",
        romaji: "Itterasshai. Ki wo tsukete.",
        vietnamese: "Bạn đi nhé. Cẩn thận đấy.",
      },
    ],
  },
  {
    id: 10,
    title: "Chào khi về nhà",
    category: "Chào hỏi",
    lines: [
      {
        role: "A",
        japanese: "ただいま。",
        romaji: "Tadaima.",
        vietnamese: "Tôi đã về rồi đây.",
      },
      {
        role: "B",
        japanese: "おかえりなさい。",
        romaji: "Okaerinasai.",
        vietnamese: "Mừng bạn đã về.",
      },
    ],
  },

  // --- 2. GIỚI THIỆU (SELF INTRO) [IDs: 11-20] ---
  {
    id: 11,
    title: "Giới thiệu bản thân ngắn gọn",
    category: "Giới thiệu",
    lines: [
      {
        role: "A",
        japanese: "はじめまして、私はミンです。",
        romaji: "Hajimemashite, watashi wa Min desu.",
        vietnamese: "Chào bạn, tôi là Minh.",
      },
      {
        role: "B",
        japanese: "私はケンです。よろしく。",
        romaji: "Watashi wa Ken desu. Yoroshiku.",
        vietnamese: "Tôi là Ken. Rất vui được gặp.",
      },
    ],
  },
  {
    id: 12,
    title: "Giới thiệu người khác",
    category: "Giới thiệu",
    lines: [
      {
        role: "A",
        japanese: "こちらは私の友達のアンさんです。",
        romaji: "Kochira wa watashi no tomodachi no An-san desu.",
        vietnamese: "Đây là bạn tôi, An.",
      },
      {
        role: "B",
        japanese: "はじめまして、アンです。",
        romaji: "Hajimemashite, An desu.",
        vietnamese: "Rất vui được gặp, tôi là An.",
      },
      {
        role: "C",
        japanese: "はじめまして。",
        romaji: "Hajimemashite.",
        vietnamese: "Chào bạn.",
      },
    ],
  },
  {
    id: 13,
    title: "Trao đổi danh thiếp",
    category: "Giới thiệu",
    lines: [
      {
        role: "A",
        japanese: "初めまして。私はABC会社の佐藤です。",
        romaji: "Hajimemashite. Watashi wa ABC kaisha no Satou desu.",
        vietnamese: "Xin chào. Tôi là Satou từ công ty ABC.",
      },
      {
        role: "B",
        japanese: "初めまして。こちらが私の名刺です。",
        romaji: "Hajimemashite. Kochira ga watashi no meishi desu.",
        vietnamese: "Chào bạn. Đây là danh thiếp của tôi.",
      },
      {
        role: "A",
        japanese: "頂戴いたします。",
        romaji: "Choudai itashimasu.",
        vietnamese: "Tôi xin nhận ạ.",
      },
    ],
  },
  {
    id: 14,
    title: "Hỏi tuổi",
    category: "Giới thiệu",
    lines: [
      {
        role: "A",
        japanese: "失礼ですが、おいくつですか？",
        romaji: "Shitsurei desu ga, oikutsu desu ka?",
        vietnamese: "Xin lỗi, bạn bao nhiêu tuổi?",
      },
      {
        role: "B",
        japanese: "25歳です。",
        romaji: "Nijuugo-sai desu.",
        vietnamese: "Tôi 25 tuổi.",
      },
      {
        role: "A",
        japanese: "私と同じですね。",
        romaji: "Watashi to onaji desu ne.",
        vietnamese: "Bằng tuổi tôi nhỉ.",
      },
    ],
  },
  {
    id: 15,
    title: "Nói về nghề nghiệp",
    category: "Giới thiệu",
    lines: [
      {
        role: "A",
        japanese: "お仕事は何ですか？",
        romaji: "Oshigoto wa nan desu ka?",
        vietnamese: "Bạn làm nghề gì?",
      },
      {
        role: "B",
        japanese: "エンジニアです。あなたは？",
        romaji: "Enjinia desu. Anata wa?",
        vietnamese: "Tôi là kỹ sư. Còn bạn?",
      },
      {
        role: "A",
        japanese: "私は教師です。",
        romaji: "Watashi wa kyoushi desu.",
        vietnamese: "Tôi là giáo viên.",
      },
    ],
  },
  {
    id: 16,
    title: "Hỏi chuyên ngành học",
    category: "Giới thiệu",
    lines: [
      {
        role: "A",
        japanese: "大学で何を勉強していますか？",
        romaji: "Daigaku de nani wo benkyou shiteimasu ka?",
        vietnamese: "Bạn học gì ở đại học?",
      },
      {
        role: "B",
        japanese: "経済を勉強しています。",
        romaji: "Keizai wo benkyou shiteimasu.",
        vietnamese: "Tôi học kinh tế.",
      },
    ],
  },
  {
    id: 17,
    title: "Hỏi nơi sống",
    category: "Giới thiệu",
    lines: [
      {
        role: "A",
        japanese: "どこに住んでいますか？",
        romaji: "Doko ni sundeimasu ka?",
        vietnamese: "Bạn đang sống ở đâu?",
      },
      {
        role: "B",
        japanese: "東京に住んでいます。",
        romaji: "Toukyou ni sundeimasu.",
        vietnamese: "Tôi sống ở Tokyo.",
      },
    ],
  },
  {
    id: 18,
    title: "Kinh nghiệm học tiếng Nhật",
    category: "Giới thiệu",
    lines: [
      {
        role: "A",
        japanese: "どのくらい日本語を勉強しましたか？",
        romaji: "Dono kurai nihongo wo benkyou shimashita ka?",
        vietnamese: "Bạn học tiếng Nhật bao lâu rồi?",
      },
      {
        role: "B",
        japanese: "約1年です。",
        romaji: "Yaku ichinen desu.",
        vietnamese: "Khoảng 1 năm.",
      },
    ],
  },
  {
    id: 19,
    title: "Trao đổi liên lạc",
    category: "Giới thiệu",
    lines: [
      {
        role: "A",
        japanese: "LINEを交換しませんか？",
        romaji: "LINE wo koukan shimasen ka?",
        vietnamese: "Trao đổi LINE không?",
      },
      {
        role: "B",
        japanese: "いいですよ。これが私のQRコードです。",
        romaji: "Ii desu yo. Kore ga watashi no QR koodo desu.",
        vietnamese: "Được chứ. Đây là mã QR của tôi.",
      },
    ],
  },
  {
    id: 20,
    title: "Biệt danh",
    category: "Giới thiệu",
    lines: [
      {
        role: "A",
        japanese: "何と呼べばいいですか？",
        romaji: "Nan to yobeba ii desu ka?",
        vietnamese: "Tôi nên gọi bạn là gì?",
      },
      {
        role: "B",
        japanese: "「ナム」と呼んでください。",
        romaji: "Namu to yonde kudasai.",
        vietnamese: "Hãy gọi tôi là Nam.",
      },
    ],
  },

  // --- 3. GIAO TIẾP (COMMUNICATION) [IDs: 21-30] ---
  {
    id: 21,
    title: "Làm quen cơ bản",
    category: "Giao tiếp",
    lines: [
      {
        role: "A",
        japanese: "こんにちは。お名前は何ですか？",
        romaji: "Konnichiwa. Onamae wa nan desu ka?",
        vietnamese: "Xin chào. Tên bạn là gì?",
      },
      {
        role: "B",
        japanese: "こんにちは。私はタインです。",
        romaji: "Konnichiwa. Watashi wa Tain desu.",
        vietnamese: "Chào bạn. Tôi là Thành.",
      },
      {
        role: "A",
        japanese: "はじめまして。",
        romaji: "Hajimemashite.",
        vietnamese: "Rất vui được gặp.",
      },
    ],
  },
  {
    id: 22,
    title: "Hỏi thăm sức khỏe",
    category: "Giao tiếp",
    lines: [
      {
        role: "A",
        japanese: "お元気ですか？",
        romaji: "Ogenki desu ka?",
        vietnamese: "Bạn có khỏe không?",
      },
      {
        role: "B",
        japanese: "はい、元気です。あなたは？",
        romaji: "Hai, genki desu. Anata wa?",
        vietnamese: "Vâng, tôi khỏe. Còn bạn?",
      },
      {
        role: "A",
        japanese: "私も元気です。",
        romaji: "Watashi mo genki desu.",
        vietnamese: "Tôi cũng khỏe.",
      },
    ],
  },
  {
    id: 23,
    title: "Nói về sở thích",
    category: "Giao tiếp",
    lines: [
      {
        role: "A",
        japanese: "趣味は何ですか？",
        romaji: "Shumi wa nan desu ka?",
        vietnamese: "Sở thích của bạn là gì?",
      },
      {
        role: "B",
        japanese: "映画を見ることです。あなたは？",
        romaji: "Eiga wo miru koto desu. Anata wa?",
        vietnamese: "Là xem phim. Còn bạn?",
      },
      {
        role: "A",
        japanese: "私はサッカーが好きです。",
        romaji: "Watashi wa sakkaa ga suki desu.",
        vietnamese: "Tôi thích bóng đá.",
      },
    ],
  },
  {
    id: 24,
    title: "Hỏi quê quán",
    category: "Giao tiếp",
    lines: [
      {
        role: "A",
        japanese: "どこから来ましたか？",
        romaji: "Doko kara kimashita ka?",
        vietnamese: "Bạn đến từ đâu?",
      },
      {
        role: "B",
        japanese: "ベトナムのハノイから来ました。",
        romaji: "Betonamu no Hanoi kara kimashita.",
        vietnamese: "Tôi đến từ Hà Nội, Việt Nam.",
      },
    ],
  },
  {
    id: 25,
    title: "Nhờ chụp ảnh giúp",
    category: "Giao tiếp",
    lines: [
      {
        role: "A",
        japanese: "すみません、写真を撮ってもらえますか？",
        romaji: "Sumimasen, shashin wo totte moraemasu ka?",
        vietnamese: "Xin lỗi, chụp giúp tôi tấm ảnh được không?",
      },
      {
        role: "B",
        japanese: "いいですよ。はい、チーズ！",
        romaji: "Ii desu yo. Hai, chiizu!",
        vietnamese: "Được chứ. Nào, cười lên!",
      },
    ],
  },
  {
    id: 26,
    title: "Không hiểu ý",
    category: "Giao tiếp",
    lines: [
      {
        role: "A",
        japanese: "日本語がわかりますか？",
        romaji: "Nihongo ga wakarimasu ka?",
        vietnamese: "Bạn có hiểu tiếng Nhật không?",
      },
      {
        role: "B",
        japanese: "いいえ、わかりません。",
        romaji: "Iie, wakarimasen.",
        vietnamese: "Không, tôi không hiểu.",
      },
    ],
  },
  {
    id: 27,
    title: "Yêu cầu nhắc lại",
    category: "Giao tiếp",
    lines: [
      {
        role: "A",
        japanese: "もっとゆっくり話してください。",
        romaji: "Motto yukkuri hanashite kudasai.",
        vietnamese: "Làm ơn nói chậm hơn một chút.",
      },
      {
        role: "B",
        japanese: "はい、わかりました。",
        romaji: "Hai, wakarimashita.",
        vietnamese: "Vâng, tôi hiểu rồi.",
      },
    ],
  },
  {
    id: 28,
    title: "Hỏi ý kiến",
    category: "Giao tiếp",
    lines: [
      {
        role: "A",
        japanese: "どう思いますか？",
        romaji: "Dou omoimasu ka?",
        vietnamese: "Bạn nghĩ sao?",
      },
      {
        role: "B",
        japanese: "いいと思います。",
        romaji: "Ii to omoimasu.",
        vietnamese: "Tôi nghĩ là tốt đấy.",
      },
    ],
  },
  {
    id: 29,
    title: "Đề nghị giúp đỡ",
    category: "Giao tiếp",
    lines: [
      {
        role: "A",
        japanese: "手伝いましょうか？",
        romaji: "Tetsudaimashou ka?",
        vietnamese: "Tôi giúp bạn nhé?",
      },
      {
        role: "B",
        japanese: "ありがとうございます。助かります。",
        romaji: "Arigatou gozaimasu. Tasukarimasu.",
        vietnamese: "Cảm ơn. Bạn cứu tôi rồi.",
      },
    ],
  },
  {
    id: 30,
    title: "Đồng ý lời mời",
    category: "Giao tiếp",
    lines: [
      {
        role: "A",
        japanese: "明日、遊びに行きませんか？",
        romaji: "Ashita, asobi ni ikimasen ka?",
        vietnamese: "Ngày mai đi chơi không?",
      },
      {
        role: "B",
        japanese: "ぜひ、行きたいです。",
        romaji: "Zehi, ikitai desu.",
        vietnamese: "Nhất định rồi, tôi muốn đi.",
      },
    ],
  },

  // --- 4. MUA SẮM (SHOPPING) [IDs: 31-40] ---
  {
    id: 31,
    title: "Mua sắm tại cửa hàng",
    category: "Mua sắm",
    lines: [
      {
        role: "A",
        japanese: "いらっしゃいませ。",
        romaji: "Irasshaimase.",
        vietnamese: "Kính chào quý khách.",
      },
      {
        role: "B",
        japanese: "これを見てもいいですか？",
        romaji: "Kore wo mite mo ii desu ka?",
        vietnamese: "Tôi xem cái này được không?",
      },
      {
        role: "A",
        japanese: "2000円です。",
        romaji: "Nisen-en desu.",
        vietnamese: "2000 yên.",
      },
    ],
  },
  {
    id: 32,
    title: "Thử quần áo",
    category: "Mua sắm",
    lines: [
      {
        role: "A",
        japanese: "試着してもいいですか？",
        romaji: "Shichaku shitemo ii desu ka?",
        vietnamese: "Tôi thử đồ được không?",
      },
      {
        role: "B",
        japanese: "はい、試着室はこちらです。",
        romaji: "Hai, shichakushitsu wa kochira desu.",
        vietnamese: "Vâng, phòng thử đồ ở hướng này.",
      },
      {
        role: "A",
        japanese: "Sサイズはありますか？",
        romaji: "S-saizu wa arimasu ka?",
        vietnamese: "Có size S không?",
      },
    ],
  },
  {
    id: 33,
    title: "Mặc cả",
    category: "Mua sắm",
    lines: [
      {
        role: "A",
        japanese: "安くしてもらえませんか？",
        romaji: "Yasuku shite moraemasen ka?",
        vietnamese: "Có thể giảm giá không?",
      },
      {
        role: "B",
        japanese: "じゃあ、3000円でどうですか？",
        romaji: "Jaa, sanzen-en de dou desu ka?",
        vietnamese: "Vậy 3000 yên thì sao?",
      },
      {
        role: "A",
        japanese: "買います。",
        romaji: "Kaimasu.",
        vietnamese: "Tôi sẽ mua.",
      },
    ],
  },
  {
    id: 34,
    title: "Tại cửa hàng tiện lợi",
    category: "Mua sắm",
    lines: [
      {
        role: "A",
        japanese: "お弁当温めますか？",
        romaji: "Obentou atatamemasu ka?",
        vietnamese: "Có hâm nóng cơm hộp không ạ?",
      },
      {
        role: "B",
        japanese: "はい、お願いします。",
        romaji: "Hai, onegaishimasu.",
        vietnamese: "Vâng, làm ơn.",
      },
      {
        role: "A",
        japanese: "袋はいりますか？",
        romaji: "Fukuro wa irimasu ka?",
        vietnamese: "Có lấy túi không ạ?",
      },
    ],
  },
  {
    id: 35,
    title: "Tìm quầy bán hàng",
    category: "Mua sắm",
    lines: [
      {
        role: "A",
        japanese: "すみません、靴売り場はどこですか？",
        romaji: "Sumimasen, kutsu uriba wa doko desu ka?",
        vietnamese: "Xin lỗi, quầy bán giày ở đâu?",
      },
      {
        role: "B",
        japanese: "3階にございます。",
        romaji: "Sangai ni gozaimasu.",
        vietnamese: "Ở tầng 3 ạ.",
      },
    ],
  },
  {
    id: 36,
    title: "Thanh toán bằng thẻ",
    category: "Mua sắm",
    lines: [
      {
        role: "A",
        japanese: "カードで払えますか？",
        romaji: "Kaado de haraemasu ka?",
        vietnamese: "Tôi trả bằng thẻ được không?",
      },
      {
        role: "B",
        japanese: "はい、VISAとMasterが使えます。",
        romaji: "Hai, Biza to Masutaa ga tsukaemasu.",
        vietnamese: "Vâng, dùng được VISA và Master ạ.",
      },
    ],
  },
  {
    id: 37,
    title: "Mua quà lưu niệm",
    category: "Mua sắm",
    lines: [
      {
        role: "A",
        japanese: "人気のお土産はどれですか？",
        romaji: "Ninki no omiyage wa dore desu ka?",
        vietnamese: "Món quà lưu niệm nào được ưa chuộng vậy?",
      },
      {
        role: "B",
        japanese: "この抹茶クッキーが人気です。",
        romaji: "Kono matcha kukkii ga ninki desu.",
        vietnamese: "Bánh quy trà xanh này rất được yêu thích.",
      },
    ],
  },
  {
    id: 38,
    title: "Hết hàng",
    category: "Mua sắm",
    lines: [
      {
        role: "A",
        japanese: "このシャツの青色はありますか？",
        romaji: "Kono shatsu no aoiro wa arimasu ka?",
        vietnamese: "Áo sơ mi này có màu xanh không?",
      },
      {
        role: "B",
        japanese: "申し訳ありません。売り切れです。",
        romaji: "Moushiwake arimasen. Urikire desu.",
        vietnamese: "Xin lỗi quý khách. Hàng đã bán hết rồi.",
      },
    ],
  },
  {
    id: 39,
    title: "Miễn thuế",
    category: "Mua sắm",
    lines: [
      {
        role: "A",
        japanese: "免税できますか？",
        romaji: "Menzei dekimasu ka?",
        vietnamese: "Có được miễn thuế không?",
      },
      {
        role: "B",
        japanese: "はい、パスポートを見せてください。",
        romaji: "Hai, pasupooto wo misete kudasai.",
        vietnamese: "Có, vui lòng cho xem hộ chiếu.",
      },
    ],
  },
  {
    id: 40,
    title: "Đổi trả hàng",
    category: "Mua sắm",
    lines: [
      {
        role: "A",
        japanese: "これを返品したいのですが。",
        romaji: "Kore wo henpin shitai no desu ga.",
        vietnamese: "Tôi muốn trả lại cái này.",
      },
      {
        role: "B",
        japanese: "レシートはありますか？",
        romaji: "Reshiito wa arimasu ka?",
        vietnamese: "Quý khách có hóa đơn không?",
      },
      {
        role: "A",
        japanese: "はい、これです。",
        romaji: "Hai, kore desu.",
        vietnamese: "Vâng, đây ạ.",
      },
    ],
  },

  // --- 5. ĂN UỐNG (DINING) [IDs: 41-50] ---
  {
    id: 41,
    title: "Gọi món tại nhà hàng",
    category: "Ăn uống",
    lines: [
      {
        role: "A",
        japanese: "ご注文はお決まりですか？",
        romaji: "Gochuumon wa okimari desu ka?",
        vietnamese: "Quý khách đã quyết định gọi món chưa?",
      },
      {
        role: "B",
        japanese: "天ぷらをください。",
        romaji: "Tempura wo kudasai.",
        vietnamese: "Cho tôi Tempura nhé.",
      },
    ],
  },
  {
    id: 42,
    title: "Đặt bàn trước",
    category: "Ăn uống",
    lines: [
      {
        role: "A",
        japanese: "予約をしたいのですが。",
        romaji: "Yoyaku wo shitai no desu ga.",
        vietnamese: "Tôi muốn đặt bàn.",
      },
      {
        role: "B",
        japanese: "何名様ですか？",
        romaji: "Nanmeisama desu ka?",
        vietnamese: "Đi mấy người ạ?",
      },
      {
        role: "A",
        japanese: "二人です。",
        romaji: "Futari desu.",
        vietnamese: "2 người.",
      },
    ],
  },
  {
    id: 43,
    title: "Hỏi về dị ứng",
    category: "Ăn uống",
    lines: [
      {
        role: "A",
        japanese: "この料理にエビは入っていますか？",
        romaji: "Kono ryouri ni ebi wa haitteimasu ka?",
        vietnamese: "Món này có tôm không?",
      },
      {
        role: "B",
        japanese: "いいえ、入っていません。",
        romaji: "Iie, haitteimasen.",
        vietnamese: "Không, không có đâu ạ.",
      },
    ],
  },
  {
    id: 44,
    title: "Thanh toán",
    category: "Ăn uống",
    lines: [
      {
        role: "A",
        japanese: "お会計をお願いします。",
        romaji: "Okaikei wo onegaishimasu.",
        vietnamese: "Làm ơn tính tiền.",
      },
      {
        role: "B",
        japanese: "別々にお願いします。",
        romaji: "Betsubetsu ni onegaishimasu.",
        vietnamese: "Làm ơn tính riêng ra.",
      },
    ],
  },
  {
    id: 45,
    title: "Đặt món tráng miệng",
    category: "Ăn uống",
    lines: [
      {
        role: "A",
        japanese: "デザートはいかがですか？",
        romaji: "Dezaato wa ikaga desu ka?",
        vietnamese: "Quý khách có dùng tráng miệng không?",
      },
      {
        role: "B",
        japanese: "アイスクリームをお願いします。",
        romaji: "Aisukuriimu wo onegaishimasu.",
        vietnamese: "Cho tôi kem nhé.",
      },
    ],
  },
  {
    id: 46,
    title: "Xin thêm nước",
    category: "Ăn uống",
    lines: [
      {
        role: "A",
        japanese: "すみません、お水をください。",
        romaji: "Sumimasen, omizu wo kudasai.",
        vietnamese: "Xin lỗi, cho tôi xin nước.",
      },
      {
        role: "B",
        japanese: "はい、ただいま。",
        romaji: "Hai, tadaima.",
        vietnamese: "Vâng, có ngay đây.",
      },
    ],
  },
  {
    id: 47,
    title: "Khen ngợi đồ ăn",
    category: "Ăn uống",
    lines: [
      {
        role: "A",
        japanese: "味はどうですか？",
        romaji: "Aji wa dou desu ka?",
        vietnamese: "Vị thế nào?",
      },
      {
        role: "B",
        japanese: "とても美味しいです。",
        romaji: "Totemo oishii desu.",
        vietnamese: "Rất là ngon.",
      },
    ],
  },
  {
    id: 48,
    title: "Cụng ly",
    category: "Ăn uống",
    lines: [
      {
        role: "A",
        japanese: "成功を祝して！",
        romaji: "Seikou wo shukushite!",
        vietnamese: "Chúc mừng thành công!",
      },
      {
        role: "B",
        japanese: "乾杯！",
        romaji: "Kanpai!",
        vietnamese: "Cạn ly! (Dô!)",
      },
    ],
  },
  {
    id: 49,
    title: "Yêu cầu không cay",
    category: "Ăn uống",
    lines: [
      {
        role: "A",
        japanese: "辛くしないでください。",
        romaji: "Karaku shinaide kudasai.",
        vietnamese: "Đừng làm cay nhé.",
      },
      {
        role: "B",
        japanese: "はい、わかりました。",
        romaji: "Hai, wakarimashita.",
        vietnamese: "Vâng, tôi hiểu rồi.",
      },
    ],
  },
  {
    id: 50,
    title: "Mang về (Take out)",
    category: "Ăn uống",
    lines: [
      {
        role: "A",
        japanese: "お持ち帰りできますか？",
        romaji: "Omochikaeri dekimasu ka?",
        vietnamese: "Có cho mang về không?",
      },
      {
        role: "B",
        japanese: "はい、できますよ。",
        romaji: "Hai, dekimasu yo.",
        vietnamese: "Vâng, được chứ ạ.",
      },
    ],
  },

  // --- 6. DI CHUYỂN (TRAVEL) [IDs: 51-60] ---
  {
    id: 51,
    title: "Hỏi đường đến nhà ga",
    category: "Di chuyển",
    lines: [
      {
        role: "A",
        japanese: "駅はどこですか？",
        romaji: "Eki wa doko desu ka?",
        vietnamese: "Nhà ga ở đâu vậy?",
      },
      {
        role: "B",
        japanese: "まっすぐ行って、右です。",
        romaji: "Massugu itte, migi desu.",
        vietnamese: "Đi thẳng, rồi rẽ phải.",
      },
      {
        role: "A",
        japanese: "遠いですか？",
        romaji: "Tooi desu ka?",
        vietnamese: "Có xa không?",
      },
    ],
  },
  {
    id: 52,
    title: "Đi taxi",
    category: "Di chuyển",
    lines: [
      {
        role: "A",
        japanese: "東京駅までお願いします。",
        romaji: "Toukyou-eki made onegaishimasu.",
        vietnamese: "Làm ơn đưa tôi đến ga Tokyo.",
      },
      {
        role: "B",
        japanese: "はい、わかりました。",
        romaji: "Hai, wakarimashita.",
        vietnamese: "Vâng, tôi hiểu rồi.",
      },
    ],
  },
  {
    id: 53,
    title: "Mua vé tàu",
    category: "Di chuyển",
    lines: [
      {
        role: "A",
        japanese: "新宿までの切符をください。",
        romaji: "Shinjuku made no kippu wo kudasai.",
        vietnamese: "Cho tôi vé đến Shinjuku.",
      },
      {
        role: "B",
        japanese: "200円です。",
        romaji: "Nihyaku-en desu.",
        vietnamese: "200 yên.",
      },
    ],
  },
  {
    id: 54,
    title: "Hỏi xe buýt",
    category: "Di chuyển",
    lines: [
      {
        role: "A",
        japanese: "このバスは京都に行きますか？",
        romaji: "Kono basu wa Kyouto ni ikimasu ka?",
        vietnamese: "Xe bus này có đi Kyoto không?",
      },
      {
        role: "B",
        japanese: "いいえ、次のバスですよ。",
        romaji: "Iie, tsugi no basu desu yo.",
        vietnamese: "Không, là chuyến xe tiếp theo cơ.",
      },
    ],
  },
  {
    id: 55,
    title: "Hỏi đường đến ngân hàng",
    category: "Di chuyển",
    lines: [
      {
        role: "A",
        japanese: "近くに銀行はありますか？",
        romaji: "Chikaku ni ginkou wa arimasu ka?",
        vietnamese: "Gần đây có ngân hàng nào không?",
      },
      {
        role: "B",
        japanese: "コンビニの隣です。",
        romaji: "Konbini no tonari desu.",
        vietnamese: "Ở bên cạnh cửa hàng tiện lợi.",
      },
    ],
  },
  {
    id: 56,
    title: "Đổi tàu",
    category: "Di chuyển",
    lines: [
      {
        role: "A",
        japanese: "どこで乗り換えですか？",
        romaji: "Doko de norikae desu ka?",
        vietnamese: "Phải đổi tàu ở đâu?",
      },
      {
        role: "B",
        japanese: "東京駅で乗り換えてください。",
        romaji: "Toukyou-eki de norikaete kudasai.",
        vietnamese: "Hãy đổi tàu ở ga Tokyo.",
      },
    ],
  },
  {
    id: 57,
    title: "Mua thẻ Suica/IC",
    category: "Di chuyển",
    lines: [
      {
        role: "A",
        japanese: "Suicaはどこで買えますか？",
        romaji: "Suika wa doko de kaemasu ka?",
        vietnamese: "Mua thẻ Suica ở đâu?",
      },
      {
        role: "B",
        japanese: "券売機で買えます。",
        romaji: "Kenbaiki de kaemasu.",
        vietnamese: "Có thể mua tại máy bán vé.",
      },
    ],
  },
  {
    id: 58,
    title: "Hỏi thời gian đi bộ",
    category: "Di chuyển",
    lines: [
      {
        role: "A",
        japanese: "歩いて何分ですか？",
        romaji: "Aruite nanpun desu ka?",
        vietnamese: "Đi bộ mất mấy phút?",
      },
      {
        role: "B",
        japanese: "10分くらいです。",
        romaji: "Juppun kurai desu.",
        vietnamese: "Khoảng 10 phút.",
      },
    ],
  },
  {
    id: 59,
    title: "Trên tàu Shinkansen",
    category: "Di chuyển",
    lines: [
      {
        role: "A",
        japanese: "ここは自由席ですか？",
        romaji: "Koko wa jiyuuseki desu ka?",
        vietnamese: "Đây là ghế tự do phải không?",
      },
      {
        role: "B",
        japanese: "いいえ、指定席です。",
        romaji: "Iie, shiteiseki desu.",
        vietnamese: "Không, là ghế chỉ định (đặt trước).",
      },
    ],
  },
  {
    id: 60,
    title: "Mất vé",
    category: "Di chuyển",
    lines: [
      {
        role: "A",
        japanese: "すみません、切符をなくしました。",
        romaji: "Sumimasen, kippu wo nakushimashita.",
        vietnamese: "Xin lỗi, tôi làm mất vé rồi.",
      },
      {
        role: "B",
        japanese: "駅員に話してください。",
        romaji: "Ekiin ni hanashite kudasai.",
        vietnamese: "Hãy nói chuyện với nhân viên nhà ga.",
      },
    ],
  },

  // --- 7. KHÁCH SẠN (HOTEL) [IDs: 61-70] ---
  {
    id: 61,
    title: "Check-in nhận phòng",
    category: "Khách sạn",
    lines: [
      {
        role: "A",
        japanese: "チェックインをお願いします。",
        romaji: "Chekku-in wo onegaishimasu.",
        vietnamese: "Tôi muốn check-in.",
      },
      {
        role: "B",
        japanese: "お名前をお書きください。",
        romaji: "Onamae wo okaki kudasai.",
        vietnamese: "Xin vui lòng viết tên vào đây.",
      },
    ],
  },
  {
    id: 62,
    title: "Báo cáo sự cố phòng",
    category: "Khách sạn",
    lines: [
      {
        role: "A",
        japanese: "お湯が出ません。",
        romaji: "Oyu ga demasen.",
        vietnamese: "Không có nước nóng.",
      },
      {
        role: "B",
        japanese: "すぐ確認します。",
        romaji: "Sugu kakunin shimasu.",
        vietnamese: "Tôi sẽ kiểm tra ngay.",
      },
    ],
  },
  {
    id: 63,
    title: "Gửi hành lý",
    category: "Khách sạn",
    lines: [
      {
        role: "A",
        japanese: "荷物を預けられますか？",
        romaji: "Nimotsu wo azukeraremasu ka?",
        vietnamese: "Tôi gửi hành lý được không?",
      },
      {
        role: "B",
        japanese: "はい、何時までですか？",
        romaji: "Hai, nanji made desu ka?",
        vietnamese: "Vâng, đến mấy giờ ạ?",
      },
    ],
  },
  {
    id: 64,
    title: "Check-out trả phòng",
    category: "Khách sạn",
    lines: [
      {
        role: "A",
        japanese: "チェックアウトしたいです。",
        romaji: "Chekku-auto shitai desu.",
        vietnamese: "Tôi muốn trả phòng.",
      },
      {
        role: "B",
        japanese: "ありがとうございます。",
        romaji: "Arigatou gozaimasu.",
        vietnamese: "Cảm ơn quý khách.",
      },
    ],
  },
  {
    id: 65,
    title: "Hỏi dịch vụ giặt ủi",
    category: "Khách sạn",
    lines: [
      {
        role: "A",
        japanese: "ランドリーサービスはありますか？",
        romaji: "Randorii saabisu wa arimasu ka?",
        vietnamese: "Có dịch vụ giặt ủi không?",
      },
      {
        role: "B",
        japanese: "はい、袋に入れてください。",
        romaji: "Hai, fukuro ni irete kudasai.",
        vietnamese: "Có, xin hãy bỏ vào túi này.",
      },
    ],
  },
  {
    id: 66,
    title: "Hỏi mật khẩu Wifi",
    category: "Khách sạn",
    lines: [
      {
        role: "A",
        japanese: "Wi-Fiのパスワードは何ですか？",
        romaji: "Wi-Fi no pasuwaado wa nan desu ka?",
        vietnamese: "Mật khẩu Wifi là gì?",
      },
      {
        role: "B",
        japanese: "カードに書いてあります。",
        romaji: "Kaado ni kaite arimasu.",
        vietnamese: "Nó được ghi trên thẻ này.",
      },
    ],
  },
  {
    id: 67,
    title: "Hỏi giờ ăn sáng",
    category: "Khách sạn",
    lines: [
      {
        role: "A",
        japanese: "朝食は何時からですか？",
        romaji: "Choushoku wa nanji kara desu ka?",
        vietnamese: "Bữa sáng bắt đầu từ mấy giờ?",
      },
      {
        role: "B",
        japanese: "7時から9時までです。",
        romaji: "Shichiji kara kuji made desu.",
        vietnamese: "Từ 7 giờ đến 9 giờ.",
      },
    ],
  },
  {
    id: 68,
    title: "Gọi báo thức",
    category: "Khách sạn",
    lines: [
      {
        role: "A",
        japanese: "明日の朝6時に起こしてください。",
        romaji: "Ashita no asa rokuji ni okoshite kudasai.",
        vietnamese: "Làm ơn gọi tôi dậy lúc 6 giờ sáng mai.",
      },
      {
        role: "B",
        japanese: "かしこまりました。",
        romaji: "Kashikomarimashita.",
        vietnamese: "Tôi đã hiểu ạ.",
      },
    ],
  },
  {
    id: 69,
    title: "Nhờ gọi taxi",
    category: "Khách sạn",
    lines: [
      {
        role: "A",
        japanese: "タクシーを呼んでもらえますか？",
        romaji: "Takushii wo yonde moraemasu ka?",
        vietnamese: "Có thể gọi taxi giúp tôi không?",
      },
      {
        role: "B",
        japanese: "はい、どちらまでですか？",
        romaji: "Hai, dochira made desu ka?",
        vietnamese: "Vâng, quý khách đi đến đâu?",
      },
    ],
  },
  {
    id: 70,
    title: "Bị khóa bên ngoài",
    category: "Khách sạn",
    lines: [
      {
        role: "A",
        japanese: "鍵を部屋に忘れました。",
        romaji: "Kagi wo heya ni wasuremashita.",
        vietnamese: "Tôi để quên chìa khóa trong phòng.",
      },
      {
        role: "B",
        japanese: "少々お待ちください。",
        romaji: "Shoushou omachi kudasai.",
        vietnamese: "Xin vui lòng đợi một chút.",
      },
    ],
  },

  // --- 8. KHẨN CẤP (EMERGENCY) [IDs: 71-80] ---
  {
    id: 71,
    title: "Mất ví",
    category: "Khẩn cấp",
    lines: [
      {
        role: "A",
        japanese: "すみません、財布をなくしました。",
        romaji: "Sumimasen, saifu wo nakushimashita.",
        vietnamese: "Xin lỗi, tôi bị mất ví.",
      },
      {
        role: "B",
        japanese: "どこでなくしましたか？",
        romaji: "Doko de nakushimashita ka?",
        vietnamese: "Bạn mất ở đâu?",
      },
      {
        role: "A",
        japanese: "電車の中です。",
        romaji: "Densha no naka desu.",
        vietnamese: "Ở trên tàu điện.",
      },
    ],
  },
  {
    id: 72,
    title: "Mua thuốc đau đầu",
    category: "Khẩn cấp",
    lines: [
      {
        role: "A",
        japanese: "頭が痛いです。薬はありますか？",
        romaji: "Atama ga itai desu. Kusuri wa arimasu ka?",
        vietnamese: "Tôi bị đau đầu. Có thuốc không?",
      },
      {
        role: "B",
        japanese: "はい、これです。",
        romaji: "Hai, kore desu.",
        vietnamese: "Vâng, đây ạ.",
      },
    ],
  },
  {
    id: 73,
    title: "Cảm thấy không khỏe",
    category: "Khẩn cấp",
    lines: [
      {
        role: "A",
        japanese: "気分が悪いです。",
        romaji: "Kibun ga warui desu.",
        vietnamese: "Tôi cảm thấy không khỏe.",
      },
      {
        role: "B",
        japanese: "救急車を呼びましょうか？",
        romaji: "Kyuukyuusha wo yobimashou ka?",
        vietnamese: "Tôi gọi xe cấp cứu nhé?",
      },
    ],
  },
  {
    id: 74,
    title: "Bị thương",
    category: "Khẩn cấp",
    lines: [
      {
        role: "A",
        japanese: "足に怪我をしました。",
        romaji: "Ashi ni kega wo shimashita.",
        vietnamese: "Tôi bị thương ở chân.",
      },
      {
        role: "B",
        japanese: "病院へ行きましょう。",
        romaji: "Byouin e ikimashou.",
        vietnamese: "Đi bệnh viện thôi.",
      },
    ],
  },
  {
    id: 75,
    title: "Báo cháy",
    category: "Khẩn cấp",
    lines: [
      {
        role: "A",
        japanese: "火事だ！逃げろ！",
        romaji: "Kaji da! Nigero!",
        vietnamese: "Cháy rồi! Chạy đi!",
      },
      {
        role: "B",
        japanese: "消防車を呼んで！",
        romaji: "Shoubousha wo yonde!",
        vietnamese: "Gọi xe cứu hỏa đi!",
      },
    ],
  },
  {
    id: 76,
    title: "Đến đồn cảnh sát",
    category: "Khẩn cấp",
    lines: [
      {
        role: "A",
        japanese: "交番はどこですか？",
        romaji: "Kouban wa doko desu ka?",
        vietnamese: "Đồn cảnh sát ở đâu?",
      },
      {
        role: "B",
        japanese: "駅の前にあります。",
        romaji: "Eki no mae ni arimasu.",
        vietnamese: "Ở trước nhà ga.",
      },
    ],
  },
  {
    id: 77,
    title: "Lạc đường",
    category: "Khẩn cấp",
    lines: [
      {
        role: "A",
        japanese: "道に迷いました。",
        romaji: "Michi ni mayoimashita.",
        vietnamese: "Tôi bị lạc đường.",
      },
      {
        role: "B",
        japanese: "どこに行きたいですか？",
        romaji: "Doko ni ikitai desu ka?",
        vietnamese: "Bạn muốn đi đâu?",
      },
    ],
  },
  {
    id: 78,
    title: "Đau bụng",
    category: "Khẩn cấp",
    lines: [
      {
        role: "A",
        japanese: "お腹が痛いです。",
        romaji: "Onaka ga itai desu.",
        vietnamese: "Tôi bị đau bụng.",
      },
      {
        role: "B",
        japanese: "トイレはあそこです。",
        romaji: "Toire wa asoko desu.",
        vietnamese: "Nhà vệ sinh ở đằng kia.",
      },
    ],
  },
  {
    id: 79,
    title: "Mất hộ chiếu",
    category: "Khẩn cấp",
    lines: [
      {
        role: "A",
        japanese: "パスポートを紛失しました。",
        romaji: "Pasupooto wo funshitsu shimashita.",
        vietnamese: "Tôi làm mất hộ chiếu rồi.",
      },
      {
        role: "B",
        japanese: "大使館に連絡してください。",
        romaji: "Taishikan ni renraku shite kudasai.",
        vietnamese: "Hãy liên lạc với đại sứ quán.",
      },
    ],
  },
  {
    id: 80,
    title: "Động đất",
    category: "Khẩn cấp",
    lines: [
      {
        role: "A",
        japanese: "地震だ！机の下に入って！",
        romaji: "Jishin da! Tsukue no shita ni haitte!",
        vietnamese: "Động đất! Chui xuống gầm bàn đi!",
      },
      {
        role: "B",
        japanese: "揺れが止まるまで待とう。",
        romaji: "Yure ga tomaru made matou.",
        vietnamese: "Hãy đợi đến khi hết rung lắc.",
      },
    ],
  },

  // --- 9. GIA ĐÌNH (FAMILY) [IDs: 81-90] ---
  {
    id: 81,
    title: "Nói về gia đình",
    category: "Gia đình",
    lines: [
      {
        role: "A",
        japanese: "何人家族ですか？",
        romaji: "Nannin kazoku desu ka?",
        vietnamese: "Gia đình bạn có mấy người?",
      },
      {
        role: "B",
        japanese: "4人です。",
        romaji: "Yonin desu.",
        vietnamese: "4 người.",
      },
    ],
  },
  {
    id: 82,
    title: "Xem ảnh gia đình",
    category: "Gia đình",
    lines: [
      {
        role: "A",
        japanese: "これは家族の写真ですか？",
        romaji: "Kore wa kazoku no shashin desu ka?",
        vietnamese: "Đây là ảnh gia đình bạn à?",
      },
      {
        role: "B",
        japanese: "はい、そうです。",
        romaji: "Hai, sou desu.",
        vietnamese: "Vâng, đúng vậy.",
      },
    ],
  },
  {
    id: 83,
    title: "Sống cùng ai",
    category: "Gia đình",
    lines: [
      {
        role: "A",
        japanese: "一人暮らしですか？",
        romaji: "Hitorigurashi desu ka?",
        vietnamese: "Bạn sống một mình à?",
      },
      {
        role: "B",
        japanese: "いいえ、両親と住んでいます。",
        romaji: "Iie, ryoushin to sundeimasu.",
        vietnamese: "Không, tôi sống cùng bố mẹ.",
      },
    ],
  },
  {
    id: 84,
    title: "Anh chị em",
    category: "Gia đình",
    lines: [
      {
        role: "A",
        japanese: "兄弟はいますか？",
        romaji: "Kyoudai wa imasu ka?",
        vietnamese: "Bạn có anh chị em không?",
      },
      {
        role: "B",
        japanese: "弟が一人います。",
        romaji: "Otouto ga hitori imasu.",
        vietnamese: "Tôi có một em trai.",
      },
    ],
  },
  {
    id: 85,
    title: "Thăm ông bà",
    category: "Gia đình",
    lines: [
      {
        role: "A",
        japanese: "週末は何をしましたか？",
        romaji: "Shuumatsu wa nani wo shimashita ka?",
        vietnamese: "Cuối tuần bạn đã làm gì?",
      },
      {
        role: "B",
        japanese: "祖父母の家に行きました。",
        romaji: "Sofubo no ie ni ikimashita.",
        vietnamese: "Tôi đã đến nhà ông bà.",
      },
    ],
  },
  {
    id: 86,
    title: "Tình trạng hôn nhân",
    category: "Gia đình",
    lines: [
      {
        role: "A",
        japanese: "結婚していますか？",
        romaji: "Kekkon shiteimasu ka?",
        vietnamese: "Bạn đã kết hôn chưa?",
      },
      {
        role: "B",
        japanese: "はい、結婚しています。",
        romaji: "Hai, kekkon shiteimasu.",
        vietnamese: "Vâng, tôi kết hôn rồi.",
      },
    ],
  },
  {
    id: 87,
    title: "Nói về con cái",
    category: "Gia đình",
    lines: [
      {
        role: "A",
        japanese: "お子さんはいますか？",
        romaji: "Okosan wa imasu ka?",
        vietnamese: "Bạn có con không?",
      },
      {
        role: "B",
        japanese: "娘が二人います。",
        romaji: "Musume ga futari imasu.",
        vietnamese: "Tôi có 2 cô con gái.",
      },
    ],
  },
  {
    id: 88,
    title: "Thú cưng",
    category: "Gia đình",
    lines: [
      {
        role: "A",
        japanese: "ペットを飼っていますか？",
        romaji: "Petto wo katteimasu ka?",
        vietnamese: "Bạn có nuôi thú cưng không?",
      },
      {
        role: "B",
        japanese: "はい、犬を飼っています。",
        romaji: "Hai, inu wo katteimasu.",
        vietnamese: "Có, tôi nuôi một con chó.",
      },
    ],
  },
  {
    id: 89,
    title: "Nghề nghiệp của bố mẹ",
    category: "Gia đình",
    lines: [
      {
        role: "A",
        japanese: "お父さんの仕事は何ですか？",
        romaji: "Otousan no shigoto wa nan desu ka?",
        vietnamese: "Bố bạn làm nghề gì?",
      },
      {
        role: "B",
        japanese: "医者です。",
        romaji: "Isha desu.",
        vietnamese: "Là bác sĩ.",
      },
    ],
  },
  {
    id: 90,
    title: "Về quê",
    category: "Gia đình",
    lines: [
      {
        role: "A",
        japanese: "いつ実家に帰りますか？",
        romaji: "Itsu jikka ni kaerimasu ka?",
        vietnamese: "Khi nào bạn về quê?",
      },
      {
        role: "B",
        japanese: "来週帰る予定です。",
        romaji: "Raishuu kaeru yotei desu.",
        vietnamese: "Tôi định tuần sau về.",
      },
    ],
  },

  // --- 10. THỜI TIẾT (WEATHER) [IDs: 91-100] ---
  {
    id: 91,
    title: "Hỏi về thời tiết",
    category: "Thời tiết",
    lines: [
      {
        role: "A",
        japanese: "今日の天気はどうですか？",
        romaji: "Kyou no tenki wa dou desu ka?",
        vietnamese: "Thời tiết hôm nay thế nào?",
      },
      {
        role: "B",
        japanese: "雨が降っています。",
        romaji: "Ame ga futteimasu.",
        vietnamese: "Trời đang mưa.",
      },
    ],
  },
  {
    id: 92,
    title: "Dự báo thời tiết",
    category: "Thời tiết",
    lines: [
      {
        role: "A",
        japanese: "明日は晴れるそうですよ。",
        romaji: "Ashita wa hareru sou desu yo.",
        vietnamese: "Nghe nói mai trời sẽ nắng đấy.",
      },
      {
        role: "B",
        japanese: "それはいいですね。",
        romaji: "Sore wa ii desu ne.",
        vietnamese: "Thế thì tốt quá.",
      },
    ],
  },
  {
    id: 93,
    title: "Mùa yêu thích",
    category: "Thời tiết",
    lines: [
      {
        role: "A",
        japanese: "どの季節が好きですか？",
        romaji: "Dono kisetsu ga suki desu ka?",
        vietnamese: "Bạn thích mùa nào?",
      },
      {
        role: "B",
        japanese: "秋が好きです。涼しいですから。",
        romaji: "Aki ga suki desu. Suzushii desu kara.",
        vietnamese: "Tôi thích mùa thu. Vì trời mát mẻ.",
      },
    ],
  },
  {
    id: 94,
    title: "Trời sắp mưa",
    category: "Thời tiết",
    lines: [
      {
        role: "A",
        japanese: "空が暗いですね。",
        romaji: "Sora ga kurai desu ne.",
        vietnamese: "Trời tối sầm lại nhỉ.",
      },
      {
        role: "B",
        japanese: "雨が降りそうですね。",
        romaji: "Ame ga furisou desu ne.",
        vietnamese: "Có vẻ sắp mưa rồi.",
      },
    ],
  },
  {
    id: 95,
    title: "Tuyết rơi",
    category: "Thời tiết",
    lines: [
      {
        role: "A",
        japanese: "わあ、雪だ！",
        romaji: "Waa, yuki da!",
        vietnamese: "Oa, tuyết kìa!",
      },
      {
        role: "B",
        japanese: "きれいですね。",
        romaji: "Kirei desu ne.",
        vietnamese: "Đẹp quá nhỉ.",
      },
    ],
  },
  {
    id: 96,
    title: "Trời nóng",
    category: "Thời tiết",
    lines: [
      {
        role: "A",
        japanese: "今日はとても暑いですね。",
        romaji: "Kyou wa totemo atsui desu ne.",
        vietnamese: "Hôm nay nóng quá nhỉ.",
      },
      {
        role: "B",
        japanese: "ええ、35度もありますよ。",
        romaji: "Ee, sanjuugo-do mo arimasu yo.",
        vietnamese: "Ừ, tận 35 độ cơ đấy.",
      },
    ],
  },
  {
    id: 97,
    title: "Gió mạnh",
    category: "Thời tiết",
    lines: [
      {
        role: "A",
        japanese: "風が強いですね。",
        romaji: "Kaze ga tsuyoi desu ne.",
        vietnamese: "Gió mạnh quá.",
      },
      {
        role: "B",
        japanese: "帽子が飛ばされそうです。",
        romaji: "Boushi ga tobasaresou desu.",
        vietnamese: "Mũ sắp bị thổi bay rồi.",
      },
    ],
  },
  {
    id: 98,
    title: "Bão đến",
    category: "Thời tiết",
    lines: [
      {
        role: "A",
        japanese: "台風が来ています。",
        romaji: "Taifuu ga kiteimasu.",
        vietnamese: "Bão đang đến.",
      },
      {
        role: "B",
        japanese: "学校は休みになりますか？",
        romaji: "Gakkou wa yasumi ni narimasu ka?",
        vietnamese: "Trường học có được nghỉ không?",
      },
    ],
  },
  {
    id: 99,
    title: "Độ ẩm cao",
    category: "Thời tiết",
    lines: [
      {
        role: "A",
        japanese: "蒸し暑いですね。",
        romaji: "Mushiatsui desu ne.",
        vietnamese: "Oi bức thật đấy.",
      },
      {
        role: "B",
        japanese: "日本の夏は湿度が高いです。",
        romaji: "Nihon no natsu wa shitsudo ga takai desu.",
        vietnamese: "Mùa hè Nhật Bản độ ẩm cao lắm.",
      },
    ],
  },
  {
    id: 100,
    title: "Ngắm hoa anh đào",
    category: "Thời tiết",
    lines: [
      {
        role: "A",
        japanese: "もうすぐ春ですね。",
        romaji: "Mousugu haru desu ne.",
        vietnamese: "Sắp đến mùa xuân rồi.",
      },
      {
        role: "B",
        japanese: "桜を見るのが楽しみです。",
        romaji: "Sakura wo miru no ga tanoshimi desu.",
        vietnamese: "Tôi mong chờ được ngắm hoa anh đào.",
      },
    ],
  },

  // --- 11. CÔNG VIỆC (WORK) [IDs: 101-110] ---
  {
    id: 101,
    title: "Hỏi lịch làm việc",
    category: "Công việc",
    lines: [
      {
        role: "A",
        japanese: "明日は仕事をしますか？",
        romaji: "Ashita wa shigoto wo shimasu ka?",
        vietnamese: "Ngày mai bạn có làm việc không?",
      },
      {
        role: "B",
        japanese: "はい、9時から5時までです。",
        romaji: "Hai, kuji kara goji made desu.",
        vietnamese: "Có, từ 9 giờ đến 5 giờ.",
      },
    ],
  },
  {
    id: 102,
    title: "Phỏng vấn xin việc",
    category: "Công việc",
    lines: [
      {
        role: "A",
        japanese: "自己紹介をお願いします。",
        romaji: "Jikoshoukai wo onegaishimasu.",
        vietnamese: "Mời bạn giới thiệu bản thân.",
      },
      {
        role: "B",
        japanese: "はい、私はグエンと申します。",
        romaji: "Hai, watashi wa Guen to moushimasu.",
        vietnamese: "Vâng, tôi tên là Nguyên.",
      },
    ],
  },
  {
    id: 103,
    title: "Đi công tác",
    category: "Công việc",
    lines: [
      {
        role: "A",
        japanese: "来週、大阪へ出張します。",
        romaji: "Raishuu, Oosaka e shucchou shimasu.",
        vietnamese: "Tuần sau tôi đi công tác Osaka.",
      },
      {
        role: "B",
        japanese: "大変ですね。",
        romaji: "Taihen desu ne.",
        vietnamese: "Vất vả nhỉ.",
      },
    ],
  },
  {
    id: 104,
    title: "Xin nghỉ phép",
    category: "Công việc",
    lines: [
      {
        role: "A",
        japanese: "明日休んでもいいですか？",
        romaji: "Ashita yasundemo ii desu ka?",
        vietnamese: "Ngày mai tôi nghỉ được không?",
      },
      {
        role: "B",
        japanese: "どうしたんですか？",
        romaji: "Doushitan desu ka?",
        vietnamese: "Có chuyện gì vậy?",
      },
      {
        role: "A",
        japanese: "熱があります。",
        romaji: "Netsu ga arimasu.",
        vietnamese: "Tôi bị sốt.",
      },
    ],
  },
  {
    id: 105,
    title: "Ăn trưa cùng đồng nghiệp",
    category: "Công việc",
    lines: [
      {
        role: "A",
        japanese: "一緒に昼ごはんを食べませんか？",
        romaji: "Issho ni hirugohan wo tabemasen ka?",
        vietnamese: "Cùng đi ăn trưa không?",
      },
      {
        role: "B",
        japanese: "いいですね。行きましょう。",
        romaji: "Ii desu ne. Ikimashou.",
        vietnamese: "Hay đấy. Đi thôi.",
      },
    ],
  },
  {
    id: 106,
    title: "Cuộc họp",
    category: "Công việc",
    lines: [
      {
        role: "A",
        japanese: "会議は何時からですか？",
        romaji: "Kaigi wa nanji kara desu ka?",
        vietnamese: "Cuộc họp bắt đầu lúc mấy giờ?",
      },
      {
        role: "B",
        japanese: "午後2時からです。",
        romaji: "Gogo niji kara desu.",
        vietnamese: "Từ 2 giờ chiều.",
      },
    ],
  },
  {
    id: 107,
    title: "Làm thêm giờ",
    category: "Công việc",
    lines: [
      {
        role: "A",
        japanese: "今日は残業しますか？",
        romaji: "Kyou wa zangyou shimasu ka?",
        vietnamese: "Hôm nay có làm thêm giờ không?",
      },
      {
        role: "B",
        japanese: "はい、仕事が終わらないので。",
        romaji: "Hai, shigoto ga owaranai node.",
        vietnamese: "Có, vì công việc chưa xong.",
      },
    ],
  },
  {
    id: 108,
    title: "Nghe điện thoại công ty",
    category: "Công việc",
    lines: [
      {
        role: "A",
        japanese: "はい、ABC会社でございます。",
        romaji: "Hai, ABC kaisha de gozaimasu.",
        vietnamese: "Vâng, đây là công ty ABC.",
      },
      {
        role: "B",
        japanese: "田中さんをお願いします。",
        romaji: "Tanaka-san wo onegaishimasu.",
        vietnamese: "Làm ơn cho tôi gặp anh Tanaka.",
      },
    ],
  },
  {
    id: 109,
    title: "Hạn chót (Deadline)",
    category: "Công việc",
    lines: [
      {
        role: "A",
        japanese: "締め切りはいつですか？",
        romaji: "Shimekiri wa itsu desu ka?",
        vietnamese: "Hạn chót là khi nào?",
      },
      {
        role: "B",
        japanese: "今週の金曜日です。",
        romaji: "Konshuu no kinyoubi desu.",
        vietnamese: "Là thứ Sáu tuần này.",
      },
    ],
  },
  {
    id: 110,
    title: "Chào khi ra về",
    category: "Công việc",
    lines: [
      {
        role: "A",
        japanese: "お先に失礼します。",
        romaji: "Osaki ni shitsurei shimasu.",
        vietnamese: "Tôi xin phép về trước.",
      },
      {
        role: "B",
        japanese: "お疲れ様でした。",
        romaji: "Otsukaresama deshita.",
        vietnamese: "Bạn đã vất vả rồi (Chào tạm biệt).",
      },
    ],
  },

  // --- 12. KHÁC (TIME & OTHERS) [IDs: 111-120] ---
  {
    id: 111,
    title: "Hỏi ngày tháng",
    category: "Khác",
    lines: [
      {
        role: "A",
        japanese: "今日は何日ですか？",
        romaji: "Kyou wa nannichi desu ka?",
        vietnamese: "Hôm nay là ngày mấy?",
      },
      {
        role: "B",
        japanese: "12月20日です。",
        romaji: "Juuni-gatsu hatsuka desu.",
        vietnamese: "Là ngày 20 tháng 12.",
      },
    ],
  },
  {
    id: 112,
    title: "Hỏi giờ",
    category: "Khác",
    lines: [
      {
        role: "A",
        japanese: "今何時ですか？",
        romaji: "Ima nanji desu ka?",
        vietnamese: "Bây giờ là mấy giờ?",
      },
      {
        role: "B",
        japanese: "午後3時半です。",
        romaji: "Gogo sanji-han desu.",
        vietnamese: "Là 3 rưỡi chiều.",
      },
    ],
  },
  {
    id: 113,
    title: "Sinh nhật",
    category: "Khác",
    lines: [
      {
        role: "A",
        japanese: "誕生日はいつですか？",
        romaji: "Tanjoubi wa itsu desu ka?",
        vietnamese: "Sinh nhật bạn khi nào?",
      },
      {
        role: "B",
        japanese: "5月5日です。",
        romaji: "Gogatsu itsuka desu.",
        vietnamese: "Ngày 5 tháng 5.",
      },
    ],
  },
  {
    id: 114,
    title: "Hỏi số lượng",
    category: "Khác",
    lines: [
      {
        role: "A",
        japanese: "りんごがいくつありますか？",
        romaji: "Ringo ga ikutsu arimasu ka?",
        vietnamese: "Có bao nhiêu quả táo?",
      },
      {
        role: "B",
        japanese: "3つあります。",
        romaji: "Mittsu arimasu.",
        vietnamese: "Có 3 quả.",
      },
    ],
  },
  {
    id: 115,
    title: "Hỏi khoảng cách",
    category: "Khác",
    lines: [
      {
        role: "A",
        japanese: "ここから学校までどのくらいですか？",
        romaji: "Koko kara gakkou made dono kurai desu ka?",
        vietnamese: "Từ đây đến trường mất bao lâu?",
      },
      {
        role: "B",
        japanese: "バスで10分くらいです。",
        romaji: "Basu de juppun kurai desu.",
        vietnamese: "Đi xe buýt khoảng 10 phút.",
      },
    ],
  },
  {
    id: 116,
    title: "Hỏi thứ trong tuần",
    category: "Khác",
    lines: [
      {
        role: "A",
        japanese: "今日は何曜日ですか？",
        romaji: "Kyou wa nanyoubi desu ka?",
        vietnamese: "Hôm nay là thứ mấy?",
      },
      {
        role: "B",
        japanese: "水曜日です。",
        romaji: "Suiyoubi desu.",
        vietnamese: "Là thứ Tư.",
      },
    ],
  },
  {
    id: 117,
    title: "Hỏi số điện thoại",
    category: "Khác",
    lines: [
      {
        role: "A",
        japanese: "電話番号は何番ですか？",
        romaji: "Denwa bangou wa nanban desu ka?",
        vietnamese: "Số điện thoại là bao nhiêu?",
      },
      {
        role: "B",
        japanese: "090-1234-5678です。",
        romaji: "Zero-kyuu-zero, ichi-ni-san-yon, go-roku-nana-hachi desu.",
        vietnamese: "Là 090-1234-5678.",
      },
    ],
  },
  {
    id: 118,
    title: "Tính tổng tiền",
    category: "Khác",
    lines: [
      {
        role: "A",
        japanese: "全部でいくらですか？",
        romaji: "Zenbu de ikura desu ka?",
        vietnamese: "Tổng cộng bao nhiêu tiền?",
      },
      {
        role: "B",
        japanese: "1500円になります。",
        romaji: "Sen-gohyakuen ni narimasu.",
        vietnamese: "Thành 1500 yên.",
      },
    ],
  },
  {
    id: 119,
    title: "Khoảng thời gian (Duration)",
    category: "Khác",
    lines: [
      {
        role: "A",
        japanese: "何時間かかりますか？",
        romaji: "Nanjikan kakarimasu ka?",
        vietnamese: "Mất mấy tiếng?",
      },
      {
        role: "B",
        japanese: "2時間かかります。",
        romaji: "Nijikan kakarimasu.",
        vietnamese: "Mất 2 tiếng.",
      },
    ],
  },
  {
    id: 120,
    title: "Năm nay là năm nào",
    category: "Khác",
    lines: [
      {
        role: "A",
        japanese: "今年は西暦何年ですか？",
        romaji: "Kotoshi wa seireki nannen desu ka?",
        vietnamese: "Năm nay là năm dương lịch bao nhiêu?",
      },
      {
        role: "B",
        japanese: "2024年です。",
        romaji: "Nisen-nijuuyon-nen desu.",
        vietnamese: "Là năm 2024.",
      },
    ],
  },
];
